{
    "place": {
        "de": "Platz",
        "en": "place"
    },
    "disponible": {
        "de": "verfügbar",
        "en": "available"
    },
    "sur": {
        "de": "von",
        "en": "of"
    },
    "Placement libre : aucune place n’est attribuée et il n’y a pas de plan à choisir. Indiquez simplement le nombre d’entrées souhaitées.": {
        "de": "Freie Platzwahl: Es gibt keine zugewiesenen Plätze und keinen Saalplan. Geben Sie einfach die gewünschte Anzahl Eintritte an.",
        "en": "Admission is unassigned: there are no allocated seats or seating plan. Enter the number of admissions you need."
    },
    "Nombre d’entrées": {
        "de": "Anzahl Eintritte",
        "en": "Number of admissions"
    },
    "Tarif": {
        "de": "Tarif",
        "en": "Price category"
    },
    "Ajouter au panier": {
        "de": "In den Warenkorb",
        "en": "Add to basket"
    },
    "Vos entrées pour cette soirée": {
        "de": "Ihre Eintritte für diesen Anlass",
        "en": "Your admissions for this event"
    },
    "Aucune entrée réservée pour l’instant.": {
        "de": "Sie haben noch keine Eintritte reserviert.",
        "en": "You have not reserved any admissions yet."
    },
    "Retirer une entrée": {
        "de": "Einen Eintritt entfernen",
        "en": "Remove an admission"
    },
    "Sous-total": {
        "de": "Zwischensumme",
        "en": "Subtotal"
    },
    "Voir mon panier": {
        "de": "Meinen Warenkorb ansehen",
        "en": "View my basket"
    },
    "Vos billets vous ont été envoyés par courriel. Pour les récupérer depuis ce navigateur, il faudrait la commande d’origine ; écrivez à l’organisateur de la soirée pour vous les faire renvoyer.": {
        "de": "Ihre Tickets wurden Ihnen per E-Mail zugestellt. Für einen erneuten Download in diesem Browser wird die ursprüngliche Bestellung benötigt. Wenden Sie sich an den Veranstalter, um die Tickets erneut zu erhalten.",
        "en": "Your tickets were sent by email. Downloading them in this browser requires the original order. Contact the organiser to have the tickets sent again."
    },
    "Vos billets vous ont été envoyés par courriel. Pour les récupérer depuis ce navigateur, il faudrait la commande d’origine ; le guichet du théâtre peut vous les renvoyer.": {
        "de": "Ihre Tickets wurden Ihnen per E-Mail zugestellt. Für einen erneuten Download in diesem Browser wird die ursprüngliche Bestellung benötigt. Die Theaterkasse kann Ihnen die Tickets erneut senden.",
        "en": "Your tickets were sent by email. Downloading them in this browser requires the original order. The theatre box office can send them again."
    },
    "Vos billets": {
        "de": "Ihre Tickets",
        "en": "Your tickets"
    },
    "Votre abonnement est ouvert. Vos soirées restent à choisir : présentez votre carte d’abonné au guichet, les billets seront émis à ce moment-là.": {
        "de": "Ihr Abonnement ist eröffnet. Die Termine müssen noch gewählt werden. Zeigen Sie Ihren Abonnementausweis an der Kasse vor; dort werden die Tickets ausgestellt.",
        "en": "Your subscription is open. You still need to choose your events. Present your subscription card at the box office to have your tickets issued."
    },
    "Télécharger mes billets (PDF)": {
        "de": "Meine Tickets herunterladen (PDF)",
        "en": "Download my tickets (PDF)"
    },
    "Un billet par page : il occupe la moitié haute de la feuille, à découper le long du pointillé.": {
        "de": "Ein Ticket pro Seite, jeweils auf der oberen Hälfte. Schneiden Sie entlang der gestrichelten Linie.",
        "en": "One ticket per page, on the upper half of the sheet. Cut along the dotted line."
    },
    "Facture n°": {
        "de": "Rechnung Nr.",
        "en": "Invoice no."
    },
    "Référence :": {
        "de": "Referenz:",
        "en": "Reference:"
    },
    "Télécharger la facture (PDF)": {
        "de": "Rechnung herunterladen (PDF)",
        "en": "Download invoice (PDF)"
    },
    "Boutique": {
        "de": "Ticketshop",
        "en": "Ticket shop"
    },
    "Abonnements": {
        "de": "Abonnemente",
        "en": "Subscriptions"
    },
    "Panier": {
        "de": "Warenkorb",
        "en": "Basket"
    },
    "Votre panier a expiré.": {
        "de": "Ihr Warenkorb ist abgelaufen.",
        "en": "Your basket has expired."
    },
    "Les places que vous aviez retenues ont été remises en vente. Elles sont peut-être encore libres : il suffit de les choisir à nouveau.": {
        "de": "Die vorgemerkten Plätze sind wieder im Verkauf. Möglicherweise sind sie noch verfügbar. Wählen Sie die Plätze erneut aus.",
        "en": "The places you held have been released for sale. They may still be available. Select them again to continue."
    },
    "Choisir de nouvelles places": {
        "de": "Neue Plätze wählen",
        "en": "Choose new places"
    },
    "— billetterie en ligne.": {
        "de": "— Online-Ticketverkauf.",
        "en": "— online ticketing."
    },
    "Les tarifs réduits sont déclaratifs : le justificatif est contrôlé à l’entrée de la salle.": {
        "de": "Ermässigte Tarife beruhen auf Ihren Angaben. Der entsprechende Nachweis wird am Eingang kontrolliert.",
        "en": "Reduced prices rely on your declaration. Supporting evidence is checked at the entrance."
    },
    "Une question sur cette soirée ? Contactez directement l’organisateur.": {
        "de": "Eine Frage zu diesem Anlass? Wenden Sie sich direkt an den Veranstalter.",
        "en": "A question about this event? Contact the organiser directly."
    },
    "Une question, un groupe, un tarif particulier ? Contactez directement le guichet du théâtre.": {
        "de": "Eine Frage, eine Gruppe oder ein besonderer Tarif? Wenden Sie sich direkt an die Theaterkasse.",
        "en": "A question, a group booking or a special price? Contact the theatre box office directly."
    },
    "Les abonnements ne sont pas en vente": {
        "de": "Abonnemente sind derzeit nicht im Verkauf",
        "en": "Subscriptions are not currently on sale"
    },
    "Aucune formule d’abonnement": {
        "de": "Keine Abonnementangebote",
        "en": "No subscription offers"
    },
    "Le théâtre ne propose pas d’abonnement en ligne pour cette saison.": {
        "de": "Das Theater bietet für diese Spielzeit keine Online-Abonnemente an.",
        "en": "The theatre does not offer online subscriptions for this season."
    },
    "Un abonnement s’achète sans compte, comme un billet. Vous recevrez votre carte d’abonné par courriel.": {
        "de": "Ein Abonnement kann wie ein Ticket ohne Konto gekauft werden. Ihren Abonnementausweis erhalten Sie per E-Mail.",
        "en": "You can buy a subscription without an account, just like a ticket. Your subscription card will be sent by email."
    },
    "soirée": {
        "de": "Anlass",
        "en": "event"
    },
    "imposées, votre fauteuil réservé pour toute la saison.": {
        "de": "festgelegte Termine, Ihr Sitzplatz bleibt während der gesamten Spielzeit reserviert.",
        "en": "fixed dates, with your seat reserved throughout the season."
    },
    "spectacles au choix dans la saison. Vous choisirez vos soirées et vos places plus tard.": {
        "de": "Aufführungen Ihrer Wahl in der Spielzeit. Termine und Plätze wählen Sie später.",
        "en": "shows of your choice during the season. You will choose your dates and places later."
    },
    "entrées à utiliser librement, seul ou à plusieurs le même soir. Vous choisirez vos soirées plus tard.": {
        "de": "frei nutzbare Eintritte, alleine oder mit mehreren Personen am selben Abend. Die Termine wählen Sie später.",
        "en": "admissions to use freely, on your own or with others at the same event. You will choose your dates later."
    },
    "Voir les": {
        "de": "Anzeigen:",
        "en": "View"
    },
    "dates": {
        "de": "Termine",
        "en": "dates"
    },
    "Tarif au guichet": {
        "de": "Preis an der Kasse",
        "en": "Box office price"
    },
    "Aucun compte n’est nécessaire pour acheter.": {
        "de": "Für den Kauf ist kein Konto erforderlich.",
        "en": "You do not need an account to buy tickets."
    },
    "La vente en ligne n’est pas ouverte.": {
        "de": "Der Online-Verkauf ist noch nicht geöffnet.",
        "en": "Online sales are not open."
    },
    "Filtrer par spectacle": {
        "de": "Nach Aufführung filtern",
        "en": "Filter by show"
    },
    "Tous les spectacles": {
        "de": "Alle Aufführungen",
        "en": "All shows"
    },
    "Filtrer par date": {
        "de": "Nach Datum filtern",
        "en": "Filter by date"
    },
    "Effacer les filtres": {
        "de": "Filter zurücksetzen",
        "en": "Clear filters"
    },
    "Aucune date à l’affiche": {
        "de": "Keine angekündigten Termine",
        "en": "No events listed"
    },
    "Tarifs et détails": {
        "de": "Preise und Details",
        "en": "Prices and details"
    },
    "Pas encore en vente": {
        "de": "Noch nicht im Verkauf",
        "en": "Not yet on sale"
    },
    "dès": {
        "de": "ab",
        "en": "from"
    },
    "Tarif du prochain siège": {
        "de": "Tarif für den nächsten Sitzplatz",
        "en": "Price category for the next seat"
    },
    "libre": {
        "de": "frei",
        "en": "available"
    },
    "Touchez un fauteuil pour le réserver. Pincez pour agrandir le plan.": {
        "de": "Tippen Sie auf einen Sitzplatz, um ihn zu reservieren. Vergrössern Sie den Plan mit zwei Fingern.",
        "en": "Tap a seat to reserve it. Pinch to zoom in on the seating plan."
    },
    "Vos places pour cette soirée": {
        "de": "Ihre Plätze für diesen Anlass",
        "en": "Your places for this event"
    },
    "Aucune place choisie pour l’instant.": {
        "de": "Sie haben noch keine Plätze ausgewählt.",
        "en": "You have not selected any places yet."
    },
    "Ajouter un autre spectacle": {
        "de": "Eine weitere Aufführung hinzufügen",
        "en": "Add another show"
    },
    "Vous avez atteint le maximum de": {
        "de": "Die Höchstzahl ist erreicht:",
        "en": "You have reached the maximum of"
    },
    "places par commande. Pour un groupe plus important, contactez directement le théâtre.": {
        "de": "Plätze pro Bestellung. Für grössere Gruppen wenden Sie sich direkt an das Theater.",
        "en": "places per order. For a larger group, contact the theatre directly."
    },
    "Vos coordonnées": {
        "de": "Ihre Kontaktdaten",
        "en": "Your contact details"
    },
    "Prénom": {
        "de": "Vorname",
        "en": "First name"
    },
    "Nom": {
        "de": "Nachname",
        "en": "Last name"
    },
    "Courriel": {
        "de": "E-Mail",
        "en": "Email"
    },
    "C’est à cette adresse que partiront vos billets.": {
        "de": "Ihre Tickets werden an diese Adresse gesendet.",
        "en": "Your tickets will be sent to this address."
    },
    "Téléphone": {
        "de": "Telefon",
        "en": "Phone"
    },
    "Facultatif. Utile seulement si une date devait changer — nous vous préviendrions plus vite qu’un courriel.": {
        "de": "Freiwillig. Falls sich ein Termin ändert, können wir Sie so schneller erreichen als per E-Mail.",
        "en": "Optional. If an event date changes, this lets us reach you faster than by email."
    },
    "Retour au panier": {
        "de": "Zurück zum Warenkorb",
        "en": "Back to basket"
    },
    "Continuer": {
        "de": "Weiter",
        "en": "Continue"
    },
    "Paiement simulé — aucun montant n’est encaissé": {
        "de": "Simulierte Zahlung — es wird kein Betrag eingezogen",
        "en": "Simulated payment — no money is collected"
    },
    "Cette installation ne prélève rien sur aucune carte et n’est reliée à aucune banque.": {
        "de": "Diese Installation belastet keine Karte und ist mit keiner Bank verbunden.",
        "en": "This installation does not charge any card and is not connected to a bank."
    },
    "Ce lien de paiement n’est pas valable sur cet appareil": {
        "de": "Dieser Zahlungslink kann auf diesem Gerät nicht verwendet werden",
        "en": "This payment link cannot be used on this device"
    },
    "Par sécurité, une commande ne peut être réglée que depuis l’onglet où elle a été passée. Reprenez votre commande depuis la billetterie, ou choisissez à nouveau vos places.": {
        "de": "Aus Sicherheitsgründen kann eine Bestellung nur in dem Tab bezahlt werden, in dem sie aufgegeben wurde. Rufen Sie Ihre Bestellung im Ticketshop auf oder wählen Sie Ihre Plätze erneut.",
        "en": "For security, an order can only be paid in the tab where it was placed. Return to your order in the ticket shop or select your places again."
    },
    "Retour à la billetterie": {
        "de": "Zurück zum Ticketshop",
        "en": "Back to the ticket shop"
    },
    "Votre commande": {
        "de": "Ihre Bestellung",
        "en": "Your order"
    },
    "Le paiement": {
        "de": "Die Zahlung",
        "en": "The payment"
    },
    "est en attente de confirmation. Cette page se met à jour automatiquement ; vos billets seront disponibles ici dès que le paiement sera confirmé.": {
        "de": "wartet auf Bestätigung. Diese Seite wird automatisch aktualisiert. Ihre Tickets sind hier verfügbar, sobald die Zahlung bestätigt ist.",
        "en": "is awaiting confirmation. This page updates automatically. Your tickets will be available here once payment is confirmed."
    },
    "Continuer le paiement sur": {
        "de": "Zahlung fortsetzen bei",
        "en": "Continue payment with"
    },
    "Payer": {
        "de": "Bezahlen",
        "en": "Pay"
    },
    "Démonstration — choisir l’issue": {
        "de": "Demonstration — Ergebnis wählen",
        "en": "Demonstration — choose an outcome"
    },
    "Ces boutons n’existent que sur une installation de démonstration. Ils servent à montrer ce que voit un client quand un paiement n’aboutit pas.": {
        "de": "Diese Schaltflächen sind nur auf einer Demonstrationsinstallation verfügbar. Sie zeigen, was bei einer nicht abgeschlossenen Zahlung angezeigt wird.",
        "en": "These buttons only appear on a demonstration installation. They show what a customer sees when a payment does not complete."
    },
    "Simuler un échec": {
        "de": "Fehlgeschlagene Zahlung simulieren",
        "en": "Simulate a failed payment"
    },
    "Abandonner la commande": {
        "de": "Bestellung abbrechen",
        "en": "Abandon order"
    },
    "Commande confirmée": {
        "de": "Bestellung bestätigt",
        "en": "Order confirmed"
    },
    "Votre paiement a été confirmé par": {
        "de": "Ihre Zahlung wurde bestätigt von",
        "en": "Your payment was confirmed by"
    },
    "Une facture avec QR-code suisse a été émise ; c’est par elle que le règlement se fait aujourd’hui.": {
        "de": "Eine Rechnung mit Schweizer QR-Code wurde ausgestellt. Der Betrag ist über diese Rechnung zu bezahlen.",
        "en": "An invoice with a Swiss QR code has been issued. Use this invoice to make your payment."
    },
    "Aucune facture n’accompagne cette commande :": {
        "de": "Dieser Bestellung liegt keine Rechnung bei:",
        "en": "No invoice is included with this order:"
    },
    "n’a pas encore enregistré ses coordonnées bancaires.": {
        "de": "hat noch keine Bankverbindung hinterlegt.",
        "en": "has not yet provided its bank details."
    },
    "Le paiement n’a pas abouti": {
        "de": "Die Zahlung wurde nicht abgeschlossen",
        "en": "The payment did not complete"
    },
    "Aucun montant n’a été prélevé et aucun billet n’a été émis.": {
        "de": "Es wurde kein Betrag belastet und kein Ticket ausgestellt.",
        "en": "No money was charged and no tickets were issued."
    },
    "Réessayer le paiement": {
        "de": "Zahlung erneut versuchen",
        "en": "Try payment again"
    },
    "Commande abandonnée": {
        "de": "Bestellung abgebrochen",
        "en": "Order abandoned"
    },
    "Vos places ont été rendues à la vente et rien ne vous a été débité. Choisissez à nouveau vos fauteuils pour recommencer.": {
        "de": "Ihre Plätze sind wieder im Verkauf; es wurde kein Betrag belastet. Wählen Sie Ihre Sitzplätze erneut, um von vorne zu beginnen.",
        "en": "Your places have been released for sale and you have not been charged. Select your seats again to start over."
    },
    "Choisir des places": {
        "de": "Plätze wählen",
        "en": "Choose places"
    },
    "Commande remboursée": {
        "de": "Bestellung zurückerstattet",
        "en": "Order refunded"
    },
    "Cette commande a été remboursée par le théâtre.": {
        "de": "Das Theater hat diese Bestellung zurückerstattet.",
        "en": "This order has been refunded by the theatre."
    },
    "Votre panier": {
        "de": "Ihr Warenkorb",
        "en": "Your basket"
    },
    "Me laisser plus de temps": {
        "de": "Mehr Zeit gewähren",
        "en": "Give me more time"
    },
    "Vous avez déjà prolongé une fois : les places ne peuvent pas être retenues davantage.": {
        "de": "Sie haben die Frist bereits einmal verlängert. Die Plätze können nicht länger vorgemerkt werden.",
        "en": "You have already extended the hold once. The places cannot be held any longer."
    },
    "au maximum": {
        "de": "höchstens",
        "en": "at most"
    },
    "Total": {
        "de": "Gesamtbetrag",
        "en": "Total"
    },
    "Continuer mes achats": {
        "de": "Weiter einkaufen",
        "en": "Continue shopping"
    },
    "Passer à la commande": {
        "de": "Zur Bestellung",
        "en": "Proceed to checkout"
    },
    "Revoir le plan de salle": {
        "de": "Saalplan erneut ansehen",
        "en": "Review seating plan"
    },
    "Revoir les places de cette soirée": {
        "de": "Plätze dieses Anlasses erneut ansehen",
        "en": "Review places for this event"
    },
    "Retirer cette ligne du panier": {
        "de": "Diese Position aus dem Warenkorb entfernen",
        "en": "Remove this item from the basket"
    },
    "Il manque vos coordonnées": {
        "de": "Ihre Kontaktdaten fehlen",
        "en": "Your contact details are missing"
    },
    "Indiquez votre nom et votre courriel pour recevoir vos billets.": {
        "de": "Geben Sie Ihren Namen und Ihre E-Mail-Adresse an, damit wir Ihnen die Tickets senden können.",
        "en": "Enter your name and email address to receive your tickets."
    },
    "Renseigner mes coordonnées": {
        "de": "Meine Kontaktdaten angeben",
        "en": "Enter my contact details"
    },
    "Récapitulatif": {
        "de": "Zusammenfassung",
        "en": "Order summary"
    },
    "Acheteur": {
        "de": "Käuferin oder Käufer",
        "en": "Buyer"
    },
    "Modifier": {
        "de": "Ändern",
        "en": "Edit"
    },
    "Votre commande n’a pas pu être ouverte": {
        "de": "Ihre Bestellung konnte nicht eröffnet werden",
        "en": "Your order could not be opened"
    },
    "Revoir mon panier": {
        "de": "Meinen Warenkorb prüfen",
        "en": "Review my basket"
    },
    "Moyen de paiement": {
        "de": "Zahlungsmittel",
        "en": "Payment method"
    },
    "Chargement des moyens de paiement…": {
        "de": "Zahlungsmittel werden geladen…",
        "en": "Loading payment methods…"
    },
    "Aucun moyen de paiement n’est disponible pour ce théâtre.": {
        "de": "Für dieses Theater ist kein Zahlungsmittel verfügbar.",
        "en": "No payment method is available for this theatre."
    },
    "Modifier mon panier": {
        "de": "Meinen Warenkorb ändern",
        "en": "Edit my basket"
    },
    "Dates": {
        "de": "Termine",
        "en": "Dates"
    },
    "Aucune date à venir pour ce spectacle.": {
        "de": "Für diese Aufführung sind keine kommenden Termine vorhanden.",
        "en": "There are no upcoming dates for this show."
    },
    "Rejoindre la liste d’attente pour cette date": {
        "de": "Für diesen Termin auf die Warteliste setzen",
        "en": "Join the waiting list for this date"
    },
    "Tarifs": {
        "de": "Tarife",
        "en": "Prices"
    },
    "Catégorie": {
        "de": "Kategorie",
        "en": "Category"
    },
    "Les tarifs réduits sont déclaratifs : le justificatif (carte AVS/AI, carte d’étudiant…) est contrôlé à l’entrée de la salle.": {
        "de": "Ermässigte Tarife beruhen auf Ihren Angaben. Der Nachweis (AHV-/IV-Ausweis, Studierendenausweis usw.) wird am Eingang kontrolliert.",
        "en": "Reduced prices rely on your declaration. Supporting evidence, such as a retirement, disability or student card, is checked at the entrance."
    },
    "Votre panier est vide": {
        "de": "Ihr Warenkorb ist leer",
        "en": "Your basket is empty"
    },
    "Voir les spectacles": {
        "de": "Aufführungen ansehen",
        "en": "View shows"
    },
    "Le plan de la série est indisponible.": {
        "de": "Der Saalplan des Serienabonnements ist nicht verfügbar.",
        "en": "The seating plan for this series is unavailable."
    },
    "← Retour aux abonnements": {
        "de": "← Zurück zu den Abonnementen",
        "en": "← Back to subscriptions"
    },
    "Choisissez votre fauteuil : il vous sera réservé pour les": {
        "de": "Wählen Sie Ihren Sitzplatz. Er bleibt für Sie reserviert für die",
        "en": "Choose your seat. It will be reserved for you for the"
    },
    "soirées de la série.": {
        "de": "Termine der Serie.",
        "en": "dates in the series."
    },
    "Plan de": {
        "de": "Plan von",
        "en": "Plan of"
    },
    "du": {
        "de": "am",
        "en": "on"
    },
    ". Disponibilité vérifiée sur les": {
        "de": ". Verfügbarkeit geprüft für die",
        "en": ". Availability checked across the"
    },
    "dates de la série.": {
        "de": "Termine der Serie.",
        "en": "dates in the series."
    },
    "Choisir une place différente à chaque représentation": {
        "de": "Für jeden Termin einen anderen Platz wählen",
        "en": "Choose a different place for each date"
    },
    "Cette formule n’a pas de représentation.": {
        "de": "Dieses Angebot enthält keine Termine.",
        "en": "This offer does not contain any dates."
    },
    "Revenir au siège commun": {
        "de": "Zum gemeinsamen Sitzplatz zurückkehren",
        "en": "Return to the same seat for every date"
    },
    "Représentations de la série": {
        "de": "Termine des Serienabonnements",
        "en": "Series dates"
    },
    "Précédente": {
        "de": "Zurück",
        "en": "Previous"
    },
    "Date suivante": {
        "de": "Nächster Termin",
        "en": "Next date"
    },
    "Rejoindre la liste d’attente": {
        "de": "Auf die Warteliste setzen",
        "en": "Join the waiting list"
    },
    "Si les places recherchées sont indisponibles, laissez une demande. Une proposition éventuelle restera limitée dans le temps. Les places actuellement disponibles restent achetables sur cette page.": {
        "de": "Falls die gewünschten Plätze nicht verfügbar sind, können Sie eine Anfrage hinterlassen. Ein allfälliges Angebot ist zeitlich befristet. Derzeit verfügbare Plätze können weiterhin auf dieser Seite gekauft werden.",
        "en": "If the places you need are unavailable, leave a request. Any offer will have a time limit. Places currently available can still be bought on this page."
    },
    "Si la demande peut être enregistrée, un lien de gestion vous est envoyé. Confirmez l’adresse pour entrer dans la file. Vérifiez les indésirables ; attendez cinq minutes avant une nouvelle demande si le message manque.": {
        "de": "Wenn die Anfrage registriert werden kann, erhalten Sie einen Verwaltungslink. Bestätigen Sie Ihre Adresse, um der Warteliste beizutreten. Prüfen Sie den Spamordner und warten Sie bei fehlender Nachricht fünf Minuten, bevor Sie eine neue Anfrage senden.",
        "en": "If the request can be registered, a management link will be emailed to you. Confirm your address to join the waiting list. Check your spam folder and wait five minutes before requesting another message."
    },
    "E-mail pour la liste d’attente": {
        "de": "E-Mail für die Warteliste",
        "en": "Waiting list email"
    },
    "Nombre de places recherchées": {
        "de": "Gewünschte Anzahl Plätze",
        "en": "Number of places requested"
    },
    "Catégorie demandée": {
        "de": "Gewünschte Kategorie",
        "en": "Requested category"
    },
    "J’accepte les messages nécessaires au suivi de cette demande. Je peux me retirer depuis le lien reçu. Cette inscription reste distincte des communications publicitaires.": {
        "de": "Ich stimme den für diese Anfrage erforderlichen Nachrichten zu. Über den erhaltenen Link kann ich mich jederzeit zurückziehen. Diese Anmeldung ist unabhängig von Werbemitteilungen.",
        "en": "I agree to the messages needed to follow up this request. I can withdraw using the link I receive. This registration is separate from marketing communications."
    },
    "Demander une inscription en attente": {
        "de": "Anmeldung auf der Warteliste anfragen",
        "en": "Request waiting list registration"
    },
    "Votre liste d’attente": {
        "de": "Ihre Warteliste",
        "en": "Your waiting list"
    },
    "Ouvrez le lien de gestion reçu par e-mail. Il donne accès à votre seule demande.": {
        "de": "Öffnen Sie den per E-Mail erhaltenen Verwaltungslink. Er gibt nur Zugriff auf Ihre eigene Anfrage.",
        "en": "Open the management link you received by email. It only gives access to your own request."
    },
    "place(s) —": {
        "de": "Platz/Plätze —",
        "en": "place(s) —"
    },
    "Confirmez l’adresse qui a reçu ce lien pour rejoindre la file d’attente. Vous acceptez les seuls messages relatifs à cette demande.": {
        "de": "Bestätigen Sie die Adresse, an die dieser Link gesendet wurde, um der Warteliste beizutreten. Sie stimmen nur den Nachrichten zu dieser Anfrage zu.",
        "en": "Confirm the address that received this link to join the waiting list. You agree only to messages about this request."
    },
    "Confirmer mon inscription en attente": {
        "de": "Meine Anmeldung auf der Warteliste bestätigen",
        "en": "Confirm my waiting list registration"
    },
    "Votre demande est confirmée. La billetterie vous écrira si une offre peut vous être proposée.": {
        "de": "Ihre Anfrage ist bestätigt. Die Kasse schreibt Ihnen, falls sie Ihnen ein Angebot machen kann.",
        "en": "Your request is confirmed. The box office will contact you if it can offer you places."
    },
    "Votre proposition de places": {
        "de": "Ihr Platzangebot",
        "en": "Your offer of places"
    },
    "Valable jusqu’au": {
        "de": "Gültig bis",
        "en": "Valid until"
    },
    ". Total :": {
        "de": ". Gesamtbetrag:",
        "en": ". Total:"
    },
    "Acceptez pour transférer ces places dans un panier vide. Vous pourrez ensuite renseigner vos coordonnées, vérifier la commande et régler avec les moyens proposés par le lieu.": {
        "de": "Nehmen Sie das Angebot an, um diese Plätze in einen leeren Warenkorb zu übernehmen. Danach können Sie Ihre Kontaktdaten angeben, die Bestellung prüfen und mit einem vom Veranstalter angebotenen Zahlungsmittel bezahlen.",
        "en": "Accept to transfer these places into an empty basket. You can then enter your contact details, check the order and pay using the methods offered by the venue."
    },
    "Accepter l’offre et ouvrir mon panier": {
        "de": "Angebot annehmen und meinen Warenkorb öffnen",
        "en": "Accept the offer and open my basket"
    },
    "Cette offre a été acceptée. Continuez depuis": {
        "de": "Dieses Angebot wurde angenommen. Fahren Sie fort über",
        "en": "This offer has been accepted. Continue using"
    },
    "votre panier": {
        "de": "Ihren Warenkorb",
        "en": "your basket"
    },
    "dans le navigateur utilisé. Si le panier a expiré, recommencez depuis la programmation ou contactez la billetterie.": {
        "de": "im verwendeten Browser. Falls der Warenkorb abgelaufen ist, beginnen Sie über das Programm erneut oder wenden Sie sich an die Kasse.",
        "en": "in the browser you used. If the basket has expired, start again from the programme or contact the box office."
    },
    "Votre demande est retirée. Ses places éventuelles ont été rendues disponibles.": {
        "de": "Ihre Anfrage wurde zurückgezogen. Allfällig reservierte Plätze sind wieder verfügbar.",
        "en": "Your request has been withdrawn. Any places it held are available again."
    },
    "Cette demande ou cette offre est expirée. Rejoignez à nouveau la liste depuis la programmation si nécessaire.": {
        "de": "Diese Anfrage oder dieses Angebot ist abgelaufen. Tragen Sie sich bei Bedarf über das Programm erneut auf der Warteliste ein.",
        "en": "This request or offer has expired. If needed, join the waiting list again from the programme."
    },
    "Me retirer de cette liste": {
        "de": "Mich von dieser Warteliste zurückziehen",
        "en": "Withdraw from this waiting list"
    },
    "Retour à la programmation": {
        "de": "Zurück zum Programm",
        "en": "Back to the programme"
    },
    "Mes démarches": {
        "de": "Meine Anliegen",
        "en": "My requests"
    },
    "Déposez une demande, échangez avec la billetterie et suivez sa décision.": {
        "de": "Reichen Sie eine Anfrage ein, tauschen Sie sich mit der Kasse aus und verfolgen Sie die Entscheidung.",
        "en": "Submit a request, exchange messages with the box office and follow its decision."
    },
    "Suivre mes demandes": {
        "de": "Meine Anfragen verfolgen",
        "en": "Follow my requests"
    },
    "Contact général :": {
        "de": "Allgemeiner Kontakt:",
        "en": "General contact:"
    },
    "Bonjour": {
        "de": "Guten Tag",
        "en": "Hello"
    },
    "Une coordonnée a changé, ou une information vous semble erronée ?": {
        "de": "Haben sich Ihre Kontaktdaten geändert oder scheint eine Angabe falsch zu sein?",
        "en": "Have your contact details changed, or does some information seem incorrect?"
    },
    "Écrivez à": {
        "de": "Schreiben Sie an",
        "en": "Write to"
    },
    "Impossible de charger cette information": {
        "de": "Diese Information konnte nicht geladen werden",
        "en": "This information could not be loaded"
    },
    "Recherche des dates disponibles…": {
        "de": "Verfügbare Termine werden gesucht…",
        "en": "Finding available dates…"
    },
    "Aucune date éligible à venir.": {
        "de": "Keine passenden kommenden Termine.",
        "en": "No eligible upcoming dates."
    },
    "Date": {
        "de": "Datum",
        "en": "Date"
    },
    "Choisir une date": {
        "de": "Datum wählen",
        "en": "Choose a date"
    },
    "Lecture des places…": {
        "de": "Plätze werden geladen…",
        "en": "Loading places…"
    },
    "Cette date n’a plus de place libre.": {
        "de": "Für diesen Termin sind keine Plätze mehr verfügbar.",
        "en": "There are no places available for this date."
    },
    "Aucun tarif de cette formule n’est disponible pour cette salle. Contactez le guichet.": {
        "de": "Für dieses Angebot ist in diesem Saal kein Tarif verfügbar. Wenden Sie sich an die Kasse.",
        "en": "No price for this offer is available in this venue. Contact the box office."
    },
    "Choisissez": {
        "de": "Wählen Sie",
        "en": "Choose"
    },
    "sur le plan de salle": {
        "de": "auf dem Saalplan",
        "en": "on the seating plan"
    },
    "Aucune place sélectionnée.": {
        "de": "Keine Plätze ausgewählt.",
        "en": "No places selected."
    },
    "Tarif de chaque billet": {
        "de": "Tarif für jedes Ticket",
        "en": "Price category for each ticket"
    },
    "— catégorie du billet": {
        "de": "— Ticketkategorie",
        "en": "— ticket category"
    },
    "Choisir un tarif": {
        "de": "Einen Tarif wählen",
        "en": "Choose a price category"
    },
    "; solde après réservation :": {
        "de": "; verbleibendes Guthaben nach der Reservation:",
        "en": "; remaining credit after reservation:"
    },
    "Tarif des entrées": {
        "de": "Tarif der Eintritte",
        "en": "Admission price category"
    },
    "Confirmer la réservation": {
        "de": "Reservation bestätigen",
        "en": "Confirm reservation"
    },
    "Réservation confirmée. Votre billet est disponible dans « Mes documents ».": {
        "de": "Reservation bestätigt. Ihr Ticket ist unter «Meine Dokumente» verfügbar.",
        "en": "Reservation confirmed. Your ticket is available under “My documents”."
    },
    "Téléchargement impossible": {
        "de": "Download nicht möglich",
        "en": "Unable to download"
    },
    "Fermer": {
        "de": "Schliessen",
        "en": "Close"
    },
    "Aucun document disponible pour le moment": {
        "de": "Derzeit sind keine Dokumente verfügbar",
        "en": "No documents are available yet"
    },
    "Ma carte d’abonné": {
        "de": "Mein Abonnementausweis",
        "en": "My subscription card"
    },
    "Mes factures": {
        "de": "Meine Rechnungen",
        "en": "My invoices"
    },
    "Le bulletin de versement se paie en scannant son QR-code depuis votre application bancaire.": {
        "de": "Der Einzahlungsschein kann durch Scannen des QR-Codes in Ihrer Banking-App bezahlt werden.",
        "en": "Pay the payment slip by scanning its QR code in your banking app."
    },
    "Mes billets": {
        "de": "Meine Tickets",
        "en": "My tickets"
    },
    "· émise le": {
        "de": "· ausgestellt am",
        "en": "· issued on"
    },
    "· référence": {
        "de": "· Referenz",
        "en": "· reference"
    },
    "Télécharger": {
        "de": "Herunterladen",
        "en": "Download"
    },
    "Votre historique est encore vide": {
        "de": "Ihr Verlauf ist noch leer",
        "en": "Your history is empty"
    },
    "Historique importé": {
        "de": "Importierter Verlauf",
        "en": "Imported history"
    },
    "Montant de l’abonnement": {
        "de": "Abonnementbetrag",
        "en": "Subscription amount"
    },
    "Reste dû": {
        "de": "Offener Betrag",
        "en": "Amount due"
    },
    "Réglé le": {
        "de": "Bezahlt am",
        "en": "Paid on"
    },
    "Vos places": {
        "de": "Ihre Plätze",
        "en": "Your places"
    },
    "Aucun siège attribué.": {
        "de": "Kein Sitzplatz zugewiesen.",
        "en": "No seat assigned."
    },
    "Prochaines dates": {
        "de": "Kommende Termine",
        "en": "Upcoming dates"
    },
    "Aucune date à venir pour l’instant.": {
        "de": "Derzeit gibt es keine kommenden Termine.",
        "en": "There are no upcoming dates yet."
    },
    "déjà vu": {
        "de": "bereits besucht",
        "en": "already attended"
    },
    "au total": {
        "de": "insgesamt",
        "en": "in total"
    },
    "Réaliser la correction après accord humain": {
        "de": "Korrektur nach menschlicher Zustimmung ausführen",
        "en": "Carry out the correction after human approval"
    },
    "Un seul acte peut être réalisé sur ce dossier. Les pièces financières d’origine sont conservées.": {
        "de": "Pro Dossier kann nur eine Massnahme ausgeführt werden. Die ursprünglichen Finanzbelege bleiben erhalten.",
        "en": "Only one action can be carried out for this case. The original financial documents are retained."
    },
    "Champ à corriger": {
        "de": "Zu korrigierendes Feld",
        "en": "Field to correct"
    },
    "Nouvelle valeur": {
        "de": "Neuer Wert",
        "en": "New value"
    },
    "Pour les coordonnées facultatives, une valeur vide efface le champ choisi.": {
        "de": "Bei freiwilligen Kontaktdaten löscht ein leerer Wert das gewählte Feld.",
        "en": "For optional contact details, an empty value clears the selected field."
    },
    "Valider uniquement l’adresse": {
        "de": "Nur die Adresse bestätigen",
        "en": "Validate the address only"
    },
    "Le billet perdu sera annulé et remplacé au même prix et à la même place. Son ancien QR et ses admissions hors ligne à synchroniser seront refusés. Les appareils déconnectés doivent actualiser leur liste.": {
        "de": "Das verlorene Ticket wird storniert und zum gleichen Preis und für den gleichen Platz ersetzt. Der alte QR-Code und nachträglich synchronisierte Offline-Zutritte werden zurückgewiesen. Geräte ohne Verbindung müssen ihre Liste aktualisieren.",
        "en": "The lost ticket will be cancelled and replaced at the same price and for the same place. Its old QR code and offline admissions submitted for synchronisation will be rejected. Disconnected devices must refresh their list."
    },
    "Le report conserve le prix d’origine. Il exige une autre date future ouverte du même programme et le respect de la politique du lieu.": {
        "de": "Eine Umbuchung behält den ursprünglichen Preis bei. Sie erfordert einen anderen offenen künftigen Termin desselben Programms und muss den Regeln des Veranstaltungsorts entsprechen.",
        "en": "A date change keeps the original price. It requires another open future date for the same programme and must follow the venue’s policy."
    },
    "Date de remplacement": {
        "de": "Ersatztermin",
        "en": "Replacement date"
    },
    "Choisir une autre date": {
        "de": "Einen anderen Termin wählen",
        "en": "Choose another date"
    },
    "Une entrée sera attribuée dans la jauge libre.": {
        "de": "Ein Eintritt innerhalb der freien Kapazität wird zugeteilt.",
        "en": "An admission will be allocated within the unassigned capacity."
    },
    "Motif de l’acte": {
        "de": "Grund der Massnahme",
        "en": "Reason for the action"
    },
    "J’ai vérifié l’identité, la demande et les conséquences de cet acte.": {
        "de": "Ich habe Identität, Anfrage und Folgen dieser Massnahme geprüft.",
        "en": "I have checked the person’s identity, the request and the consequences of this action."
    },
    "Confirmer et réaliser l’acte": {
        "de": "Bestätigen und Massnahme ausführen",
        "en": "Confirm and carry out the action"
    },
    "Envoi incertain : vérifiez les journaux avant tout renvoi, qui pourrait créer un doublon.": {
        "de": "Unklarer Versandstatus: Prüfen Sie vor erneutem Versand die Protokolle, um eine doppelte Nachricht zu vermeiden.",
        "en": "Delivery is uncertain. Check the logs before sending again, as this could create a duplicate message."
    },
    "Motif de reprise du courriel": {
        "de": "Grund für die erneute E-Mail-Prüfung",
        "en": "Reason for retrying the email"
    },
    "J’ai contrôlé l’absence de réception et le destinataire.": {
        "de": "Ich habe den fehlenden Empfang und den Empfänger überprüft.",
        "en": "I have checked that the message was not received and that the recipient is correct."
    },
    "Reprendre cet envoi": {
        "de": "Diesen Versand erneut prüfen",
        "en": "Retry this delivery"
    },
    "Qualifier la demande": {
        "de": "Anfrage bearbeiten",
        "en": "Review the request"
    },
    "Changer l’état ne réalise aucun remboursement, report ou correction. La réponse ci-dessous est visible du spectateur.": {
        "de": "Ein Statuswechsel bewirkt keine Rückerstattung, Umbuchung oder Korrektur. Die folgende Antwort ist für die anfragende Person sichtbar.",
        "en": "Changing the status does not carry out a refund, date change or correction. The response below is visible to the customer."
    },
    "Nouvel état": {
        "de": "Neuer Status",
        "en": "New status"
    },
    "Réponse de qualification": {
        "de": "Antwort zur Bearbeitung",
        "en": "Review response"
    },
    "M’attribuer ce dossier": {
        "de": "Dieses Dossier mir zuweisen",
        "en": "Assign this case to me"
    },
    "Enregistrer l’état et la réponse": {
        "de": "Status und Antwort speichern",
        "en": "Save status and response"
    },
    "Retour aux demandes": {
        "de": "Zurück zu den Anfragen",
        "en": "Back to requests"
    },
    "— Responsable :": {
        "de": "— Verantwortlich:",
        "en": "— Assigned to:"
    },
    "Nouvelle adresse proposée :": {
        "de": "Vorgeschlagene neue Adresse:",
        "en": "Proposed new address:"
    },
    "Renvoyer le lien de vérification": {
        "de": "Bestätigungslink erneut senden",
        "en": "Resend the verification link"
    },
    "Vérifiez la nouvelle boîte de réception. Un nouvel envoi est possible après cinq minutes.": {
        "de": "Prüfen Sie den Posteingang der neuen Adresse. Ein erneuter Versand ist nach fünf Minuten möglich.",
        "en": "Check the inbox of the new address. You can request another message after five minutes."
    },
    "Résultat de la demande": {
        "de": "Ergebnis der Anfrage",
        "en": "Request outcome"
    },
    "Télécharger le billet corrigé": {
        "de": "Korrigiertes Ticket herunterladen",
        "en": "Download the corrected ticket"
    },
    "Décision :": {
        "de": "Entscheidung:",
        "en": "Decision:"
    },
    "Échanges du dossier": {
        "de": "Nachrichten zum Dossier",
        "en": "Case messages"
    },
    "Charger les messages précédents": {
        "de": "Frühere Nachrichten laden",
        "en": "Load earlier messages"
    },
    "Note interne, invisible du spectateur": {
        "de": "Interne Notiz, für die anfragende Person nicht sichtbar",
        "en": "Internal note, hidden from the customer"
    },
    "Retirer ma demande": {
        "de": "Meine Anfrage zurückziehen",
        "en": "Withdraw my request"
    },
    "Notifications RidoMio": {
        "de": "RidoMio-Benachrichtigungen",
        "en": "RidoMio notifications"
    },
    "Nouvelle demande à la billetterie": {
        "de": "Neue Anfrage an die Kasse",
        "en": "New request to the box office"
    },
    "La billetterie étudie votre demande. Le dépôt ne modifie ni votre billet, ni votre paiement.": {
        "de": "Die Kasse prüft Ihre Anfrage. Das Einreichen ändert weder Ihr Ticket noch Ihre Zahlung.",
        "en": "The box office will review your request. Submitting it does not change your ticket or payment."
    },
    "Type de demande": {
        "de": "Art der Anfrage",
        "en": "Request type"
    },
    "Objet de la demande": {
        "de": "Betreff der Anfrage",
        "en": "Request subject"
    },
    "Billet concerné": {
        "de": "Betroffenes Ticket",
        "en": "Ticket concerned"
    },
    "Nouvelle adresse e-mail proposée (facultatif)": {
        "de": "Vorgeschlagene neue E-Mail-Adresse (freiwillig)",
        "en": "Proposed new email address (optional)"
    },
    "Un lien est envoyé à cette nouvelle adresse. Votre connexion reste inchangée jusqu’à validation humaine.": {
        "de": "Ein Link wird an diese neue Adresse gesendet. Ihre Anmeldung bleibt bis zur menschlichen Bestätigung unverändert.",
        "en": "A link will be sent to the new address. Your sign-in remains unchanged until a person approves the change."
    },
    "Description de votre demande": {
        "de": "Beschreibung Ihrer Anfrage",
        "en": "Describe your request"
    },
    "Déposer ma demande": {
        "de": "Meine Anfrage einreichen",
        "en": "Submit my request"
    },
    "Politique de traitement des demandes": {
        "de": "Regeln zur Bearbeitung von Anfragen",
        "en": "Request handling policy"
    },
    "Les reports conservent le prix de la commande d’origine. Toute décision reste humaine et tracée.": {
        "de": "Bei Umbuchungen bleibt der Preis der ursprünglichen Bestellung erhalten. Jede Entscheidung wird von einer Person getroffen und protokolliert.",
        "en": "Date changes retain the price of the original order. Every decision is made by a person and recorded."
    },
    "Autoriser le report individuel au même programme": {
        "de": "Individuelle Umbuchung innerhalb desselben Programms zulassen",
        "en": "Allow individual date changes within the same programme"
    },
    "Délai minimal avant la séance d’origine (heures)": {
        "de": "Mindestabstand vor dem ursprünglichen Termin (Stunden)",
        "en": "Minimum time before the original event (hours)"
    },
    "Autoriser la réémission d’un billet perdu": {
        "de": "Ersatzausstellung eines verlorenen Tickets zulassen",
        "en": "Allow reissuing a lost ticket"
    },
    "Enregistrer la politique des demandes": {
        "de": "Regeln für Anfragen speichern",
        "en": "Save the request policy"
    },
    "Politique enregistrée.": {
        "de": "Regeln gespeichert.",
        "en": "Policy saved."
    },
    "Nouvelle demande": {
        "de": "Neue Anfrage",
        "en": "New request"
    },
    "État de la demande": {
        "de": "Status der Anfrage",
        "en": "Request status"
    },
    "Tous les états": {
        "de": "Alle Status",
        "en": "All statuses"
    },
    "Aucune demande ne correspond à ces filtres.": {
        "de": "Keine Anfrage entspricht diesen Filtern.",
        "en": "No requests match these filters."
    },
    "Pages des demandes": {
        "de": "Seiten der Anfragen",
        "en": "Request pages"
    },
    "Page précédente": {
        "de": "Vorherige Seite",
        "en": "Previous page"
    },
    "Page": {
        "de": "Seite",
        "en": "Page"
    },
    "Page suivante": {
        "de": "Nächste Seite",
        "en": "Next page"
    },
    "Vérification de la nouvelle adresse": {
        "de": "Neue Adresse bestätigen",
        "en": "Verify the new address"
    },
    "Ce geste prouve que vous recevez le courrier ici. La billetterie doit ensuite approuver le changement de votre profil.": {
        "de": "Damit weisen Sie nach, dass Sie Nachrichten an dieser Adresse erhalten. Die Kasse muss die Änderung Ihres Profils anschliessend genehmigen.",
        "en": "This proves that you receive messages at this address. The box office must then approve the change to your profile."
    },
    "Adresse vérifiée. La billetterie peut désormais examiner la correction. Votre connexion actuelle reste inchangée.": {
        "de": "Adresse bestätigt. Die Kasse kann die Korrektur nun prüfen. Ihre aktuelle Anmeldung bleibt unverändert.",
        "en": "Address verified. The box office can now review the correction. Your current sign-in remains unchanged."
    },
    "Vérifier ma nouvelle adresse": {
        "de": "Meine neue Adresse bestätigen",
        "en": "Verify my new address"
    },
    "Accès refusé": {
        "de": "Zugriff verweigert",
        "en": "Access denied"
    },
    "Retour à l’accueil": {
        "de": "Zurück zur Startseite",
        "en": "Back to home"
    },
    "Vérification de la session…": {
        "de": "Sitzung wird geprüft…",
        "en": "Checking your session…"
    },
    "Vérifiez vos emails": {
        "de": "Prüfen Sie Ihre E-Mails",
        "en": "Check your email"
    },
    "Si l’adresse": {
        "de": "Wenn die Adresse",
        "en": "If the address"
    },
    "est connue": {
        "de": "bekannt ist",
        "en": "is recognised"
    },
    "15 minutes": {
        "de": "15 Minuten",
        "en": "15 minutes"
    },
    "et ne fonctionne qu’une fois.": {
        "de": "und kann nur einmal verwendet werden.",
        "en": "and can only be used once."
    },
    "Pensez à regarder dans les indésirables.": {
        "de": "Prüfen Sie auch den Spamordner.",
        "en": "Remember to check your spam folder."
    },
    "Utiliser une autre adresse": {
        "de": "Eine andere Adresse verwenden",
        "en": "Use another address"
    },
    "Adresse email": {
        "de": "E-Mail-Adresse",
        "en": "Email address"
    },
    "prenom.nom@exemple.ch": {
        "de": "vorname.nachname@beispiel.ch",
        "en": "first.last@example.ch"
    },
    "Recevoir mon lien de connexion": {
        "de": "Meinen Anmeldelink erhalten",
        "en": "Send me a sign-in link"
    },
    "Connexion du personnel (back-office)": {
        "de": "Anmeldung für Mitarbeitende (Backoffice)",
        "en": "Staff sign-in (back office)"
    },
    "Espace personnel": {
        "de": "Persönlicher Bereich",
        "en": "Personal area"
    },
    "Mot de passe": {
        "de": "Passwort",
        "en": "Password"
    },
    "Se connecter": {
        "de": "Anmelden",
        "en": "Sign in"
    },
    "Mot de passe oublié ? Les comptes du personnel sont créés et réinitialisés par votre administrateur.": {
        "de": "Passwort vergessen? Konten für Mitarbeitende werden von Ihrer Administration erstellt und zurückgesetzt.",
        "en": "Forgot your password? Staff accounts are created and reset by your administrator."
    },
    "Connexion en cours…": {
        "de": "Anmeldung läuft…",
        "en": "Signing in…"
    },
    "Connexion impossible": {
        "de": "Anmeldung nicht möglich",
        "en": "Unable to sign in"
    },
    "Les liens expirent après 15 minutes et ne servent qu’une fois : demandez-en un nouveau.": {
        "de": "Links laufen nach 15 Minuten ab und können nur einmal verwendet werden. Fordern Sie einen neuen Link an.",
        "en": "Links expire after 15 minutes and can only be used once. Request a new link."
    },
    "Demander un nouveau lien": {
        "de": "Einen neuen Link anfordern",
        "en": "Request a new link"
    },
    "Se déconnecter": {
        "de": "Abmelden",
        "en": "Sign out"
    },
    "Chargement de l’écran…": {
        "de": "Ansicht wird geladen…",
        "en": "Loading the page…"
    },
    "Mes demandes": {
        "de": "Meine Anfragen",
        "en": "My requests"
    },
    "Il ne reste plus de place disponible pour cette date.": {
        "de": "Für diesen Termin sind keine Plätze mehr verfügbar.",
        "en": "There are no places available for this date."
    },
    "Vous avez atteint le maximum d’entrées par commande. Pour un groupe plus important, contactez directement l’organisateur.": {
        "de": "Die maximale Anzahl Eintritte pro Bestellung ist erreicht. Für grössere Gruppen wenden Sie sich direkt an den Veranstalter.",
        "en": "You have reached the maximum number of admissions per order. For a larger group, contact the organiser directly."
    },
    "Entrée": {
        "de": "Eintritt",
        "en": "Admission"
    },
    "Panier expiré": {
        "de": "Warenkorb abgelaufen",
        "en": "Basket expired"
    },
    "Facture acquittée. Aucun règlement supplémentaire à effectuer.": {
        "de": "Rechnung bezahlt. Es ist keine weitere Zahlung erforderlich.",
        "en": "Invoice paid. No further payment is required."
    },
    "Bulletin de versement avec QR-code suisse, à régler depuis votre application bancaire.": {
        "de": "Einzahlungsschein mit Schweizer QR-Code zur Zahlung in Ihrer Banking-App.",
        "en": "Payment slip with a Swiss QR code, payable in your banking app."
    },
    "Le courriel n’a pas pu partir. Vos documents sont bien émis : téléchargez-les maintenant, ou écrivez à l’organisateur pour vous les faire renvoyer.": {
        "de": "Die E-Mail konnte nicht gesendet werden. Ihre Dokumente sind ausgestellt. Laden Sie sie jetzt herunter oder bitten Sie den Veranstalter um erneuten Versand.",
        "en": "The email could not be sent. Your documents have been issued. Download them now or contact the organiser to have them sent again."
    },
    "Le courriel n’a pas pu partir. Vos documents sont bien émis : téléchargez-les maintenant, ou demandez au guichet de vous les renvoyer.": {
        "de": "Die E-Mail konnte nicht gesendet werden. Ihre Dokumente sind ausgestellt. Laden Sie sie jetzt herunter oder bitten Sie die Kasse um erneuten Versand.",
        "en": "The email could not be sent. Your documents have been issued. Download them now or ask the box office to send them again."
    },
    "L’envoi par courriel est en cours.": {
        "de": "Die E-Mail wird versandt.",
        "en": "The email is being sent."
    },
    "Entrées": {
        "de": "Eintritte",
        "en": "Admissions"
    },
    "Spectacles": {
        "de": "Aufführungen",
        "en": "Shows"
    },
    "Choisir mon fauteuil": {
        "de": "Meinen Sitzplatz wählen",
        "en": "Choose my seat"
    },
    "Billetterie": {
        "de": "Ticketverkauf",
        "en": "Ticketing"
    },
    "Aucune représentation ne correspond à ce filtre. Essayez une autre date ou un autre spectacle.": {
        "de": "Kein Termin entspricht diesem Filter. Versuchen Sie ein anderes Datum oder eine andere Aufführung.",
        "en": "No events match this filter. Try another date or show."
    },
    "Le programme de la saison n’est pas encore en vente. Revenez bientôt.": {
        "de": "Das Programm der Spielzeit ist noch nicht im Verkauf. Schauen Sie bald wieder vorbei.",
        "en": "The season programme is not on sale yet. Please check again soon."
    },
    "Ouverture de la vente à venir": {
        "de": "Verkaufsstart folgt",
        "en": "Sales will open later"
    },
    "Plus de place disponible": {
        "de": "Keine Plätze mehr verfügbar",
        "en": "No places available"
    },
    "tarif au guichet": {
        "de": "Tarif an der Kasse",
        "en": "box office price"
    },
    "Choisissez des places avant de passer commande.": {
        "de": "Wählen Sie vor der Bestellung Plätze aus.",
        "en": "Choose places before placing an order."
    },
    "Saisissez un nom (200 caractères au maximum).": {
        "de": "Geben Sie einen Nachnamen mit höchstens 200 Zeichen ein.",
        "en": "Enter a last name of no more than 200 characters."
    },
    "Saisissez un prénom (200 caractères au maximum).": {
        "de": "Geben Sie einen Vornamen mit höchstens 200 Zeichen ein.",
        "en": "Enter a first name of no more than 200 characters."
    },
    "Saisissez une adresse courriel valide.": {
        "de": "Geben Sie eine gültige E-Mail-Adresse ein.",
        "en": "Enter a valid email address."
    },
    "Saisissez un téléphone valide, de 6 à 30 caractères (ex. 079 123 45 67).": {
        "de": "Geben Sie eine gültige Telefonnummer mit 6 bis 30 Zeichen ein (z. B. 079 123 45 67).",
        "en": "Enter a valid phone number of 6 to 30 characters, such as 079 123 45 67."
    },
    "Vérifiez ce champ.": {
        "de": "Prüfen Sie dieses Feld.",
        "en": "Check this field."
    },
    "Corrigez les champs indiqués. Vos places et votre saisie sont conservées.": {
        "de": "Korrigieren Sie die markierten Felder. Ihre Plätze und Eingaben bleiben erhalten.",
        "en": "Correct the marked fields. Your places and entered details are retained."
    },
    "Montant remboursé": {
        "de": "Zurückerstatteter Betrag",
        "en": "Amount refunded"
    },
    "Montant réglé": {
        "de": "Bezahlter Betrag",
        "en": "Amount paid"
    },
    "Montant à régler": {
        "de": "Zu zahlender Betrag",
        "en": "Amount due"
    },
    "Paiement": {
        "de": "Zahlung",
        "en": "Payment"
    },
    " — paiement reçu": {
        "de": " — Zahlung erhalten",
        "en": " — payment received"
    },
    " — facture à régler": {
        "de": " — Rechnung offen",
        "en": " — invoice to pay"
    },
    "Vos places restent retenues jusqu’à la fin du compte à rebours. Passé ce délai, elles repartent automatiquement à la vente.": {
        "de": "Ihre Plätze bleiben bis zum Ende des Countdowns vorgemerkt. Danach werden sie automatisch wieder zum Verkauf freigegeben.",
        "en": "Your places are held until the countdown ends. They are then automatically released for sale."
    },
    "Votre abonnement est enregistré. Votre carte est envoyée par email et disponible dans votre espace abonné.": {
        "de": "Ihr Abonnement ist registriert. Ihre Karte wird per E-Mail gesendet und ist in Ihrem persönlichen Bereich verfügbar.",
        "en": "Your subscription is registered. Your card is sent by email and is available in your personal area."
    },
    "Le règlement se fait directement auprès de lui.": {
        "de": "Die Zahlung erfolgt direkt an den Veranstalter.",
        "en": "Payment is made directly to the organiser."
    },
    "Le règlement se fait auprès de son guichet.": {
        "de": "Die Zahlung erfolgt an seiner Kasse.",
        "en": "Payment is made through its box office."
    },
    " Vos places sont toujours retenues : vous pouvez réessayer tout de suite.": {
        "de": " Ihre Plätze bleiben vorgemerkt. Sie können die Zahlung sofort erneut versuchen.",
        "en": " Your places are still held. You can try payment again now."
    },
    " Vos places ont été rendues à la vente ; il faut les choisir à nouveau.": {
        "de": " Ihre Plätze sind wieder im Verkauf. Wählen Sie sie erneut aus.",
        "en": " Your places have been released for sale. You need to select them again."
    },
    "Vos places sont retenues plus longtemps.": {
        "de": "Ihre Plätze bleiben länger vorgemerkt.",
        "en": "Your places are held for longer."
    },
    "Abonnement": {
        "de": "Abonnement",
        "en": "Subscription"
    },
    "Vous choisirez vos soirées après l’achat": {
        "de": "Ihre Termine wählen Sie nach dem Kauf",
        "en": "You will choose your dates after purchase"
    },
    "Il n’y a rien à commander.": {
        "de": "Es gibt nichts zu bestellen.",
        "en": "There is nothing to order."
    },
    "Passer au paiement": {
        "de": "Zur Zahlung",
        "en": "Proceed to payment"
    },
    "Valider ma commande": {
        "de": "Meine Bestellung bestätigen",
        "en": "Confirm my order"
    },
    "← Retour": {
        "de": "← Zurück",
        "en": "← Back"
    },
    "← Tous les spectacles": {
        "de": "← Alle Aufführungen",
        "en": "← All shows"
    },
    "Les tarifs de cette soirée sont communiqués par l’organisateur.": {
        "de": "Die Tarife dieses Anlasses teilt der Veranstalter mit.",
        "en": "The organiser provides prices for this event."
    },
    "Les tarifs de ce spectacle sont communiqués au guichet du théâtre.": {
        "de": "Die Tarife dieser Aufführung erfahren Sie an der Theaterkasse.",
        "en": "The theatre box office provides prices for this show."
    },
    "D’autres tarifs existent : renseignez-vous directement auprès de l’organisateur.": {
        "de": "Weitere Tarife sind verfügbar. Fragen Sie direkt beim Veranstalter nach.",
        "en": "Other prices are available. Contact the organiser directly for details."
    },
    "D’autres tarifs existent et se prennent directement au guichet du théâtre.": {
        "de": "Weitere Tarife sind direkt an der Theaterkasse erhältlich.",
        "en": "Other prices are available directly from the theatre box office."
    },
    "Choisissez une soirée pour commencer.": {
        "de": "Wählen Sie einen Anlass, um zu beginnen.",
        "en": "Choose an event to get started."
    },
    "Aucun fauteuil sélectionné.": {
        "de": "Kein Sitzplatz ausgewählt.",
        "en": "No seat selected."
    },
    "Aucune place commune n’est disponible pour toute la série. Choisissez un fauteuil pour chaque représentation.": {
        "de": "Für die gesamte Serie ist kein gemeinsamer Sitzplatz verfügbar. Wählen Sie für jeden Termin einen Sitzplatz.",
        "en": "No single seat is available across the whole series. Choose a seat for each date."
    },
    "Choisissez un fauteuil pour chaque représentation.": {
        "de": "Wählen Sie für jeden Termin einen Sitzplatz.",
        "en": "Choose a seat for each date."
    },
    "Mes documents": {
        "de": "Meine Dokumente",
        "en": "My documents"
    },
    "Chargement de vos documents…": {
        "de": "Ihre Dokumente werden geladen…",
        "en": "Loading your documents…"
    },
    "Mon historique": {
        "de": "Mein Verlauf",
        "en": "My history"
    },
    "Chargement de votre historique…": {
        "de": "Ihr Verlauf wird geladen…",
        "en": "Loading your history…"
    },
    "Réessayez dans un instant.": {
        "de": "Versuchen Sie es in Kürze erneut.",
        "en": "Try again in a moment."
    },
    "Fermer la réservation": {
        "de": "Reservation schliessen",
        "en": "Close reservation"
    },
    "Réserver une date avec mes droits": {
        "de": "Mit meinem Guthaben einen Termin reservieren",
        "en": "Reserve a date using my entitlement"
    },
    "Choisissez un spectacle encore inutilisé et une place.": {
        "de": "Wählen Sie eine noch nicht besuchte Aufführung und einen Platz.",
        "en": "Choose a show you have not used yet and a place."
    },
    "Choisissez une date, puis les places sur le plan. Chaque place utilise une entrée du carnet.": {
        "de": "Wählen Sie einen Termin und dann die Plätze auf dem Plan. Jeder Platz verwendet einen Eintritt des Mehrfachabonnements.",
        "en": "Choose a date, then places on the plan. Each place uses one admission from your multi-entry subscription."
    },
    "votre place": {
        "de": "Ihren Platz",
        "en": "your place"
    },
    "Place indisponible": {
        "de": "Platz nicht verfügbar",
        "en": "Place unavailable"
    },
    "entrée sera décomptée": {
        "de": "Eintritt wird abgezogen",
        "en": "admission will be used"
    },
    "entrées seront décomptées": {
        "de": "Eintritte werden abgezogen",
        "en": "admissions will be used"
    },
    "La réservation n’a pas abouti. Vérifiez la disponibilité et vos droits.": {
        "de": "Die Reservation wurde nicht abgeschlossen. Prüfen Sie die Verfügbarkeit und Ihr Guthaben.",
        "en": "The reservation did not complete. Check availability and your entitlement."
    },
    "Vos billets apparaîtront ici dès qu’ils seront prêts.": {
        "de": "Ihre Tickets erscheinen hier, sobald sie bereit sind.",
        "en": "Your tickets will appear here as soon as they are ready."
    },
    "Votre carte et vos billets apparaîtront ici dès qu’ils seront prêts.": {
        "de": "Ihre Karte und Tickets erscheinen hier, sobald sie bereit sind.",
        "en": "Your card and tickets will appear here as soon as they are ready."
    },
    "Impossible de télécharger cette carte.": {
        "de": "Diese Karte konnte nicht heruntergeladen werden.",
        "en": "Unable to download this card."
    },
    "Impossible de télécharger ce billet.": {
        "de": "Dieses Ticket konnte nicht heruntergeladen werden.",
        "en": "Unable to download this ticket."
    },
    "Autres venues": {
        "de": "Weitere Besuche",
        "en": "Other visits"
    },
    "pièces vues": {
        "de": "besuchte Aufführungen",
        "en": "shows attended"
    },
    "pièce vue": {
        "de": "besuchte Aufführung",
        "en": "show attended"
    },
    "spectacles restants": {
        "de": "verbleibende Aufführungen",
        "en": "shows remaining"
    },
    "spectacle restant": {
        "de": "verbleibende Aufführung",
        "en": "show remaining"
    },
    "entrées restantes": {
        "de": "verbleibende Eintritte",
        "en": "admissions remaining"
    },
    "entrée restante": {
        "de": "verbleibender Eintritt",
        "en": "admission remaining"
    },
    "Bonjour,": {
        "de": "Guten Tag,",
        "en": "Hello,"
    },
    "à préciser": {
        "de": "noch anzugeben",
        "en": "to be provided"
    },
    "Adresse": {
        "de": "Adresse",
        "en": "Address"
    },
    "Localité": {
        "de": "Ort",
        "en": "Town"
    },
    "vérifiée": {
        "de": "bestätigt",
        "en": "verified"
    },
    "en attente de vérification": {
        "de": "Bestätigung ausstehend",
        "en": "awaiting verification"
    },
    "Aucun billet corrigé à télécharger.": {
        "de": "Kein korrigiertes Ticket zum Herunterladen.",
        "en": "There is no corrected ticket to download."
    },
    "non attribué": {
        "de": "nicht zugewiesen",
        "en": "unassigned"
    },
    "vérification en attente": {
        "de": "Bestätigung ausstehend",
        "en": "verification pending"
    },
    "Spectateur": {
        "de": "Besucherin oder Besucher",
        "en": "Customer"
    },
    " — Note interne": {
        "de": " — Interne Notiz",
        "en": " — Internal note"
    },
    "Réponse ou note": {
        "de": "Antwort oder Notiz",
        "en": "Reply or note"
    },
    "Votre message": {
        "de": "Ihre Nachricht",
        "en": "Your message"
    },
    "Enregistrer la note interne": {
        "de": "Interne Notiz speichern",
        "en": "Save the internal note"
    },
    "Envoyer le message dans le dossier": {
        "de": "Nachricht im Dossier senden",
        "en": "Send the message in the case"
    },
    "Courriel envoyé": {
        "de": "E-Mail gesendet",
        "en": "Email sent"
    },
    "Courriel réservé, réception à vérifier": {
        "de": "E-Mail vorgemerkt, Empfang zu prüfen",
        "en": "Email reserved, receipt to be checked"
    },
    "Réception incertaine": {
        "de": "Empfang unklar",
        "en": "Receipt uncertain"
    },
    "Choisir le billet concerné": {
        "de": "Betroffenes Ticket wählen",
        "en": "Choose the ticket concerned"
    },
    "Sans billet particulier": {
        "de": "Kein bestimmtes Ticket",
        "en": "No specific ticket"
    },
    "Demandes des spectateurs": {
        "de": "Anfragen der Besuchenden",
        "en": "Customer requests"
    },
    "Mes demandes à la billetterie": {
        "de": "Meine Anfragen an die Kasse",
        "en": "My requests to the box office"
    },
    "Non attribuée": {
        "de": "Nicht zugewiesen",
        "en": "Unassigned"
    },
    "Corriger mes coordonnées": {
        "de": "Meine Kontaktdaten korrigieren",
        "en": "Correct my contact details"
    },
    "Signaler un billet perdu": {
        "de": "Ein verlorenes Ticket melden",
        "en": "Report a lost ticket"
    },
    "Demander un changement de date": {
        "de": "Einen Terminwechsel anfragen",
        "en": "Request a date change"
    },
    "Contacter la salle": {
        "de": "Den Veranstaltungsort kontaktieren",
        "en": "Contact the venue"
    },
    "Ouverte": {
        "de": "Offen",
        "en": "Open"
    },
    "En examen": {
        "de": "In Bearbeitung",
        "en": "Under review"
    },
    "En attente de votre réponse": {
        "de": "Ihre Antwort ausstehend",
        "en": "Awaiting your reply"
    },
    "Résolue": {
        "de": "Erledigt",
        "en": "Resolved"
    },
    "Refusée": {
        "de": "Abgelehnt",
        "en": "Declined"
    },
    "Retirée": {
        "de": "Zurückgezogen",
        "en": "Withdrawn"
    },
    "Impossible d’envoyer le lien de connexion.": {
        "de": "Der Anmeldelink konnte nicht gesendet werden.",
        "en": "Unable to send the sign-in link."
    },
    "Lien de connexion incomplet.": {
        "de": "Unvollständiger Anmeldelink.",
        "en": "Incomplete sign-in link."
    },
    "Ce lien de connexion n’est plus valable.": {
        "de": "Dieser Anmeldelink ist nicht mehr gültig.",
        "en": "This sign-in link is no longer valid."
    },
    "Vous pouvez réserver les dates de vos formules au choix et carnets depuis cet espace.": {
        "de": "In diesem Bereich können Sie Termine für Ihre Wahl- und Mehrfachabonnemente reservieren.",
        "en": "You can reserve dates for your choice and multi-entry subscriptions in this area."
    },
    " Pour corriger vos coordonnées, signaler un billet perdu ou demander un report, ouvrez ": {
        "de": " Um Ihre Kontaktdaten zu korrigieren, ein verlorenes Ticket zu melden oder einen Terminwechsel anzufragen, öffnen Sie ",
        "en": " To correct your contact details, report a lost ticket or request a date change, open "
    },
    ". La billetterie examine et valide chaque dossier.": {
        "de": ". Die Kasse prüft und bestätigt jedes Dossier.",
        "en": ". The box office reviews and validates each case."
    },
    "NPA": {
        "de": "PLZ",
        "en": "Postcode"
    },
    "Attention : vos places sont réservées encore {temps} minutes.": {
        "de": "Achtung: Ihre Plätze sind noch {temps} Minuten reserviert.",
        "en": "Warning: your places are reserved for another {temps} minutes."
    },
    "Places réservées encore {temps} minutes.": {
        "de": "Plätze noch {temps} Minuten reserviert.",
        "en": "Places reserved for another {temps} minutes."
    },
    "Tout a été envoyé à {email}.": {
        "de": "Alle Dokumente wurden an {email} gesendet.",
        "en": "All documents have been sent to {email}."
    },
    "« {nom} » a été ajouté à votre panier.": {
        "de": "«{nom}» wurde Ihrem Warenkorb hinzugefügt.",
        "en": "“{nom}” has been added to your basket."
    },
    "Retirer la place {place}": {
        "de": "Platz {place} entfernen",
        "en": "Remove place {place}"
    },
    "Aucun compte à créer. Ces informations servent à vous envoyer vos billets et à vous joindre si {representation} devait changer.": {
        "de": "Sie müssen kein Konto erstellen. Diese Angaben dienen dem Ticketversand und der Kontaktaufnahme, falls sich {representation} ändert.",
        "en": "No account is needed. These details are used to send your tickets and contact you if {representation} changes."
    },
    "Je souhaite recevoir par courriel le programme et les nouveautés de {nom}.": {
        "de": "Ich möchte das Programm und Neuigkeiten von {nom} per E-Mail erhalten.",
        "en": "I would like to receive the programme and news from {nom} by email."
    },
    "Facultatif, et sans effet sur votre commande. Vos billets, votre facture et vos liens de connexion vous parviennent dans tous les cas. Vous pouvez le retirer à tout moment en écrivant à {exploitant}.": {
        "de": "Freiwillig und ohne Einfluss auf Ihre Bestellung. Tickets, Rechnung und Anmeldelinks erhalten Sie in jedem Fall. Ein Widerruf ist jederzeit möglich. Kontakt: {exploitant}.",
        "en": "Optional and with no effect on your order. You will receive your tickets, invoice and sign-in links in all cases. You may withdraw consent at any time. Contact: {exploitant}."
    },
    "Ces informations sont transmises à {nom}, qui les utilise pour vous remettre vos billets, votre facture, et vous joindre si {representation} devait changer. Elles ne sont ni vendues ni transmises à des tiers à des fins de prospection. Pour y accéder, les corriger ou en demander la suppression, écrivez à {exploitant}.": {
        "de": "Diese Angaben gehen an {nom} für den Ticket- und Rechnungsversand sowie die Kontaktaufnahme, falls sich {representation} ändert. Sie werden weder verkauft noch für Werbezwecke an Dritte weitergegeben. Für Auskunft, Berichtigung oder Löschung wenden Sie sich bitte an die zuständige Stelle. Kontakt: {exploitant}.",
        "en": "These details are sent to {nom} to deliver your tickets and invoice and contact you if {representation} changes. They are neither sold nor shared with third parties for marketing. To access, correct or request deletion of your data, contact: {exploitant}."
    },
    "La session {prestataire} expire après 30 minutes. Les places restent temporairement réservées pendant la vérification du paiement.": {
        "de": "Die Sitzung bei {prestataire} läuft nach 30 Minuten ab. Die Plätze bleiben während der Zahlungsprüfung vorübergehend reserviert.",
        "en": "The {prestataire} session expires after 30 minutes. Places remain temporarily reserved while payment is being checked."
    },
    "Vous serez redirigé vers la page sécurisée de {prestataire}. Vos billets seront émis après confirmation du paiement.": {
        "de": "Sie werden auf die sichere Zahlungsseite von {prestataire} weitergeleitet. Ihre Tickets werden nach der Zahlungsbestätigung ausgestellt.",
        "en": "You will be redirected to the secure {prestataire} payment page. Your tickets will be issued after payment is confirmed."
    },
    "« {nom} » n’a pas encore de dates : la souscription en ligne n’est pas possible.": {
        "de": "Für «{nom}» sind noch keine Termine erfasst. Ein Onlinekauf ist deshalb nicht möglich.",
        "en": "“{nom}” has no dates yet, so it cannot be purchased online."
    },
    "Ce fauteuil n’est pas disponible pour {spectacle} le {date}.": {
        "de": "Dieser Sitzplatz ist für {spectacle} am {date} nicht verfügbar.",
        "en": "This seat is not available for {spectacle} on {date}."
    },
    "Ma {saison}": {
        "de": "Meine {saison}",
        "en": "My {saison}"
    },
    "Chargement de votre {saison}…": {
        "de": "Ihre {saison} wird geladen…",
        "en": "Loading your {saison}…"
    },
    "Contactez {exploitant}, qui fera la correction pour vous.": {
        "de": "Die zuständige Stelle nimmt die Korrektur für Sie vor. Kontakt: {exploitant}.",
        "en": "The venue team can make the correction for you. Contact: {exploitant}."
    },
    "jusqu’à {maximum} places": {
        "de": "bis zu {maximum} Plätze",
        "en": "up to {maximum} places"
    },
    "C’est normal : il se construira au fil de vos venues, à chaque fois que votre billet sera scanné à l’entrée. Revenez après votre prochaine {representation}.": {
        "de": "Ihr Verlauf wächst mit jedem Besuch, sobald Ihr Ticket am Eingang gescannt wird. Schauen Sie nach dem nächsten Termin wieder vorbei ({representation}).",
        "en": "Your history will grow with each visit when your ticket is scanned at the entrance. Check back after your next {representation}."
    },
    "Aucun abonnement actif pour {saison} en cours": {
        "de": "Kein aktives Abonnement für den laufenden Zeitraum ({saison})",
        "en": "No active subscription for the current period ({saison})"
    },
    "Si vous pensez qu’il s’agit d’une erreur, contactez {exploitant} : c’est lui qui gère les abonnements.": {
        "de": "Wenn Sie einen Fehler vermuten, wenden Sie sich an die für Abonnemente zuständige Stelle. Kontakt: {exploitant}.",
        "en": "If you think this is an error, contact the team that manages subscriptions: {exploitant}."
    },
    "Saisissez l’adresse email communiquée {exploitant}. Vous recevrez un lien de connexion : ni mot de passe à créer, ni mot de passe à retenir.": {
        "de": "Geben Sie die hinterlegte E-Mail-Adresse ein. Zuständige Stelle: {exploitant}. Sie erhalten einen Anmeldelink und benötigen kein Passwort.",
        "en": "Enter the email address registered with {exploitant}. You will receive a sign-in link, with no password to create or remember."
    },
    "Pas d’email chez {exploitant}, ou adresse à corriger ? Contactez le guichet. Les corrections de coordonnées et les changements de place se font par {responsable}.": {
        "de": "Keine E-Mail-Adresse hinterlegt oder eine Korrektur nötig? Kontaktieren Sie die Kasse. Zuständige Stelle: {exploitant}. Änderungen an Kontaktdaten und Plätzen bearbeitet: {responsable}.",
        "en": "No email registered with {exploitant}, or need to correct it? Contact the box office. Contact details and seat changes are handled by {responsable}."
    },
    "Si l’adresse {email} est connue, un lien de connexion vient d’y être envoyé. Il est valable 15 minutes et ne fonctionne qu’une fois.": {
        "de": "Wenn die Adresse {email} bekannt ist, wurde ein Anmeldelink dorthin gesendet. Er ist 15 Minuten gültig und kann nur einmal verwendet werden.",
        "en": "If {email} is registered, a sign-in link has been sent to it. It is valid for 15 minutes and can only be used once."
    },
    "{nombre} billet a été émis à votre nom.": {
        "de": "{nombre} Ticket wurde auf Ihren Namen ausgestellt.",
        "en": "{nombre} ticket has been issued in your name."
    },
    "{nombre} billets ont été émis à votre nom.": {
        "de": "{nombre} Tickets wurden auf Ihren Namen ausgestellt.",
        "en": "{nombre} tickets have been issued in your name."
    },
    "{nombre} place disponible sur {capacite}": {
        "de": "{nombre} Platz von {capacite} verfügbar",
        "en": "{nombre} place available out of {capacite}"
    },
    "{nombre} places disponibles sur {capacite}": {
        "de": "{nombre} Plätze von {capacite} verfügbar",
        "en": "{nombre} places available out of {capacite}"
    },
    "{nombre} place sur {capacite}": {
        "de": "{nombre} Platz von {capacite}",
        "en": "{nombre} place out of {capacite}"
    },
    "{nombre} places sur {capacite}": {
        "de": "{nombre} Plätze von {capacite}",
        "en": "{nombre} places out of {capacite}"
    },
    "{nombre} soirée": {
        "de": "{nombre} Abend",
        "en": "{nombre} evening"
    },
    "{nombre} soirées": {
        "de": "{nombre} Abende",
        "en": "{nombre} evenings"
    },
    "Espace abonné": {
        "de": "Abonnentenbereich",
        "en": "Subscriber area"
    },
    "Vous faites partie de l’organisation ?": {
        "de": "Gehören Sie zum Organisationsteam?",
        "en": "Are you part of the organising team?"
    },
    "Vous travaillez au théâtre ?": {
        "de": "Arbeiten Sie im Theater?",
        "en": "Do you work at the theatre?"
    },
    "Places disponibles": {
        "de": "Plätze verfügbar",
        "en": "Places available"
    },
    "Dernières places": {
        "de": "Letzte Plätze",
        "en": "Last places"
    },
    "Complet": {
        "de": "Ausverkauft",
        "en": "Sold out"
    },
    "Libre": {
        "de": "Frei",
        "en": "Available"
    },
    "Vendu": {
        "de": "Verkauft",
        "en": "Sold"
    },
    "Invitation": {
        "de": "Einladung",
        "en": "Complimentary"
    },
    "Hors vente": {
        "de": "Nicht im Verkauf",
        "en": "Not for sale"
    },
    "Réservé campagne": {
        "de": "Für die Kampagne reserviert",
        "en": "Reserved for the campaign"
    },
    "Réservé abonnement": {
        "de": "Für ein Abonnement reserviert",
        "en": "Reserved for a subscription"
    },
    "Retenu par un autre": {
        "de": "Anderweitig vorgemerkt",
        "en": "Held by someone else"
    },
    "Indisponible": {
        "de": "Nicht verfügbar",
        "en": "Unavailable"
    },
    "Sélectionné": {
        "de": "Ausgewählt",
        "en": "Selected"
    },
    "sélectionné": {
        "de": "ausgewählt",
        "en": "selected"
    },
    "consulter les détails, sélection désactivée": {
        "de": "Details anzeigen, Auswahl deaktiviert",
        "en": "view details, selection disabled"
    },
    "lecture seule, sélection désactivée": {
        "de": "nur Ansicht, Auswahl deaktiviert",
        "en": "read only, selection disabled"
    },
    "Chargement…": {
        "de": "Wird geladen…",
        "en": "Loading…"
    },
    "Scène": {
        "de": "Bühne",
        "en": "Stage"
    },
    "Emplacements PMR et accompagnants": {
        "de": "Rollstuhl- und Begleitplätze",
        "en": "Wheelchair and companion places"
    },
    "Choisissez ensemble les deux places, puis les tarifs adaptés. Chaque place peut aussi être sélectionnée séparément. La salle peut vous conseiller sur l’accueil et l’accès.": {
        "de": "Wählen Sie beide Plätze zusammen und anschliessend die passenden Tarife. Jeder Platz kann auch einzeln gewählt werden. Das Team vor Ort berät Sie zum Zugang und Empfang.",
        "en": "Select both places together, then the appropriate prices. Each place can also be selected separately. The venue team can advise on access and assistance."
    },
    "Les deux places doivent être disponibles.": {
        "de": "Beide Plätze müssen verfügbar sein.",
        "en": "Both places must be available."
    },
    "Ce duo dépasse le nombre de places de cette sélection.": {
        "de": "Dieses Paar überschreitet die erlaubte Anzahl Plätze.",
        "en": "This pair exceeds the number of places allowed in this selection."
    },
    "Choisir le duo PMR {pmr} / accompagnant {accompagnant}": {
        "de": "Rollstuhlplatz {pmr} und Begleitplatz {accompagnant} wählen",
        "en": "Select wheelchair place {pmr} and companion place {accompagnant}"
    },
    "Plan de salle — flèches pour circuler, Entrée pour choisir un siège": {
        "de": "Saalplan — mit Pfeiltasten navigieren, mit Eingabetaste einen Platz wählen",
        "en": "Seating plan — use arrow keys to navigate, Enter to select a seat"
    },
    "Plan de salle": {
        "de": "Saalplan",
        "en": "Seating plan"
    },
    "Vue rapprochée sur les premiers rangs. Glissez pour vous déplacer, pincez à deux doigts pour zoomer.": {
        "de": "Die ersten Reihen sind vergrössert. Ziehen Sie zum Verschieben und verwenden Sie zwei Finger zum Zoomen.",
        "en": "The front rows are zoomed in. Drag to move, pinch with two fingers to zoom."
    },
    "Pincez à deux doigts pour zoomer, glissez pour vous déplacer. Les numéros de siège apparaissent en agrandissant.": {
        "de": "Verwenden Sie zwei Finger zum Zoomen und ziehen Sie zum Verschieben. Die Platznummern werden beim Vergrössern eingeblendet.",
        "en": "Pinch with two fingers to zoom, drag to move. Seat numbers appear as you zoom in."
    },
    "Voir toute la salle": {
        "de": "Ganzen Saal anzeigen",
        "en": "View the whole venue"
    },
    "Agrandir": {
        "de": "Vergrössern",
        "en": "Zoom in"
    },
    "Réduire": {
        "de": "Verkleinern",
        "en": "Zoom out"
    },
    "Réinitialiser le zoom": {
        "de": "Zoom zurücksetzen",
        "en": "Reset zoom"
    },
    "Sélection complète : {nombre} sièges. Retirez-en un avant d’en ajouter un autre.": {
        "de": "Auswahl vollständig: {nombre} Plätze. Entfernen Sie einen Platz, bevor Sie einen weiteren hinzufügen.",
        "en": "Selection complete: {nombre} seats. Remove one before adding another."
    },
    "{place} retiré de la sélection.": {
        "de": "{place} aus der Auswahl entfernt.",
        "en": "{place} removed from the selection."
    },
    "{place} sélectionné.": {
        "de": "{place} ausgewählt.",
        "en": "{place} selected."
    },
    "{place} n’appartient pas à la zone de cette formule.": {
        "de": "{place} gehört nicht zum Bereich dieses Abonnements.",
        "en": "{place} is outside the area allowed by this subscription."
    },
    "Emplacement PMR": {
        "de": "Rollstuhlplatz",
        "en": "Wheelchair place"
    },
    "Accompagnant PMR": {
        "de": "Begleitplatz",
        "en": "Companion place"
    },
    "Standard": {
        "de": "Standard",
        "en": "Standard"
    },
    "JJ.MM.AAAA": {
        "de": "TT.MM.JJJJ",
        "en": "DD.MM.YYYY"
    },
    "Ouvrir le calendrier": {
        "de": "Kalender öffnen",
        "en": "Open calendar"
    },
    "Mois précédent": {
        "de": "Vorheriger Monat",
        "en": "Previous month"
    },
    "Mois suivant": {
        "de": "Nächster Monat",
        "en": "Next month"
    },
    "Effacer la date": {
        "de": "Datum löschen",
        "en": "Clear date"
    },
    "Heure": {
        "de": "Uhrzeit",
        "en": "Time"
    },
    "Agrandir le plan": {
        "de": "Plan vergrössern",
        "en": "Zoom in on plan"
    },
    "Réduire le plan": {
        "de": "Plan verkleinern",
        "en": "Zoom out of plan"
    },
    "Revoir le plan entier": {
        "de": "Ganzen Plan anzeigen",
        "en": "View the whole plan"
    },
    "Vue d’ensemble": {
        "de": "Übersicht",
        "en": "Overview"
    },
    "Carte d’abonné": {
        "de": "Abonnementskarte",
        "en": "Subscription card"
    },
    "Saison": {
        "de": "Spielzeit",
        "en": "Season"
    },
    "Titulaire": {
        "de": "Inhaber/in",
        "en": "Holder"
    },
    "Formule": {
        "de": "Abonnement",
        "en": "Subscription"
    },
    "PLACES": {
        "de": "PLÄTZE",
        "en": "PLACES"
    },
    "Cette carte admet tout le foyer inscrit à la souscription. Présentez son QR à l’entrée de chaque représentation couverte par la formule.": {
        "de": "Diese Karte gilt für alle im Abonnement erfassten Haushaltsmitglieder. Zeigen Sie den QR-Code beim Eingang jeder im Abonnement enthaltenen Vorstellung vor.",
        "en": "This card admits everyone in the household registered on the subscription. Show its QR code at the entrance to every performance included in the subscription."
    },
    "BILLET": {
        "de": "TICKET",
        "en": "TICKET"
    },
    "ANNULÉ — ENTRÉE REFUSÉE": {
        "de": "STORNIERT — KEIN EINLASS",
        "en": "CANCELLED — NO ADMISSION"
    },
    "Date et heure": {
        "de": "Datum und Uhrzeit",
        "en": "Date and time"
    },
    "Siège": {
        "de": "Sitzplatz",
        "en": "Seat"
    },
    "Place": {
        "de": "Platz",
        "en": "Place"
    },
    "Montant": {
        "de": "Betrag",
        "en": "Amount"
    },
    "Code à dicter au contrôle si la lecture du QR échoue.": {
        "de": "Falls der QR-Code nicht lesbar ist, nennen Sie diesen Code am Eingang.",
        "en": "Give this code at the entrance if the QR code cannot be read."
    },
    "Découper le long du pointillé": {
        "de": "Entlang der gestrichelten Linie ausschneiden",
        "en": "Cut along the dotted line"
    },
    "Spectacle": {
        "de": "Vorstellung",
        "en": "Show"
    },
    "Événement": {
        "de": "Veranstaltung",
        "en": "Event"
    },
    "Facture n° {numero}": {
        "de": "Rechnung Nr. {numero}",
        "en": "Invoice no. {numero}"
    },
    "Facture n° {numero} — {theatre}": {
        "de": "Rechnung Nr. {numero} — {theatre}",
        "en": "Invoice no. {numero} — {theatre}"
    },
    "ACQUITTÉE — aucun règlement à effectuer": {
        "de": "BEZAHLT — keine Zahlung erforderlich",
        "en": "PAID — no payment required"
    },
    "Émise le {date}": {
        "de": "Ausgestellt am {date}",
        "en": "Issued on {date}"
    },
    "FACTURE ANNULÉE — ne pas payer": {
        "de": "RECHNUNG STORNIERT — nicht bezahlen",
        "en": "INVOICE CANCELLED — do not pay"
    },
    "DESTINATAIRE": {
        "de": "EMPFÄNGER",
        "en": "RECIPIENT"
    },
    "DÉSIGNATION": {
        "de": "BEZEICHNUNG",
        "en": "DESCRIPTION"
    },
    "MONTANT": {
        "de": "BETRAG",
        "en": "AMOUNT"
    },
    "Total réglé": {
        "de": "Bezahlter Gesamtbetrag",
        "en": "Total paid"
    },
    "Total à payer": {
        "de": "Zu zahlender Gesamtbetrag",
        "en": "Total due"
    },
    "Règlement reçu en ligne. Aucun bulletin de versement n’est joint.": {
        "de": "Onlinezahlung eingegangen. Es liegt kein Einzahlungsschein bei.",
        "en": "Online payment received. No payment slip is enclosed."
    },
    "Compte : {compte}": {
        "de": "Konto: {compte}",
        "en": "Account: {compte}"
    },
    "Référence : {reference}": {
        "de": "Referenz: {reference}",
        "en": "Reference: {reference}"
    },
    "Votre carte d’abonné — {theatre}": {
        "de": "Ihre Abonnementskarte — {theatre}",
        "en": "Your subscription card — {theatre}"
    },
    "Vos billets — {theatre}": {
        "de": "Ihre Tickets — {theatre}",
        "en": "Your tickets — {theatre}"
    },
    "Bonjour {nom},": {
        "de": "Guten Tag {nom},",
        "en": "Hello {nom},"
    },
    "Voici votre carte d’abonné pour la saison, en pièce jointe.": {
        "de": "Im Anhang finden Sie Ihre Abonnementskarte für diese Spielzeit.",
        "en": "Your subscription card for the season is attached."
    },
    "Présentez son QR à l’entrée de chaque représentation couverte par votre formule.": {
        "de": "Zeigen Sie den QR-Code beim Eingang jeder in Ihrem Abonnement enthaltenen Vorstellung vor.",
        "en": "Show its QR code at the entrance to every performance included in your subscription."
    },
    "Voici vos billets en pièce jointe. Présentez leur QR à l’entrée.": {
        "de": "Im Anhang finden Sie Ihre Tickets. Zeigen Sie die QR-Codes am Eingang vor.",
        "en": "Your tickets are attached. Show their QR codes at the entrance."
    },
    "Généré par RidoMio": {
        "de": "Erstellt mit RidoMio",
        "en": "Generated by RidoMio"
    },
    "Choisissez votre soirée, puis votre place sur le plan de la salle.": {
        "de": "Wählen Sie einen Termin und anschliessend Ihren Platz auf dem Saalplan.",
        "en": "Choose an evening, then select your seat on the seating plan."
    },
    "Choisissez votre soirée, puis votre nombre d’entrées : les places ne sont pas numérotées.": {
        "de": "Wählen Sie einen Termin und die Anzahl Eintritte. Die Plätze sind nicht nummeriert.",
        "en": "Choose an evening and the number of admissions. Places are not numbered."
    },
    "Choisissez votre soirée, puis vos places.": {
        "de": "Wählen Sie einen Termin und anschliessend Ihre Plätze.",
        "en": "Choose an evening, then your places."
    },
    "Réponse du serveur illisible.": {
        "de": "Die Serverantwort ist nicht lesbar.",
        "en": "The server response could not be read."
    },
    "Le siège {siege} est retenu par un autre visiteur{jusqua} : il n’est pas disponible pour l’instant.": {
        "de": "Platz {siege} ist für einen anderen Besucher vorgemerkt{jusqua} und derzeit nicht verfügbar.",
        "en": "Seat {siege} is held by another visitor{jusqua} and is currently unavailable."
    },
    "Solde insuffisant : {demande} entrée(s) demandée(s), {solde} restante(s) sur ce carnet.": {
        "de": "Nicht genügend Guthaben: {demande} Eintritte angefragt, {solde} auf dieser Mehrfachkarte übrig.",
        "en": "Insufficient credit: {demande} admissions requested, {solde} remaining on this multi-entry pass."
    },
    "« {spectacle} » est déjà consommé sur cet abonnement : un spectacle ne compte qu'une fois.": {
        "de": "«{spectacle}» wurde mit diesem Abonnement bereits genutzt. Jede Vorstellung zählt nur einmal.",
        "en": "“{spectacle}” has already been used on this subscription. Each show can only count once."
    },
    "Cet abonnement couvre {nombre} spectacle(s) : le quota est atteint.": {
        "de": "Dieses Abonnement umfasst {nombre} Vorstellungen. Das Kontingent ist ausgeschöpft.",
        "en": "This subscription covers {nombre} shows. The allowance has been reached."
    },
    "Le siège {siege} n'appartient pas à la zone « {zone} » de cette formule.": {
        "de": "Platz {siege} gehört nicht zum Bereich «{zone}» dieses Abonnements.",
        "en": "Seat {siege} is outside the “{zone}” area allowed by this subscription."
    },
    "Le siège {siege} est réservé par une proposition de réabonnement en attente.": {
        "de": "Platz {siege} ist für eine ausstehende Abonnementsverlängerung reserviert.",
        "en": "Seat {siege} is reserved for a pending subscription renewal."
    },
    "Le siège {siege} est réservé par l'abonnement de {payeur} : il n'est pas disponible.": {
        "de": "Platz {siege} ist durch das Abonnement von {payeur} reserviert und nicht verfügbar.",
        "en": "Seat {siege} is reserved by the subscription of {payeur} and is unavailable."
    },
    "Cette représentation est annulée : aucun billet ne peut y être créé.": {
        "de": "Diese Vorstellung wurde abgesagt. Es können keine Tickets dafür ausgestellt werden.",
        "en": "This performance is cancelled. No tickets can be issued for it."
    },
    "La vente en ligne n’est pas ouverte : {raison}": {
        "de": "Der Onlineverkauf ist nicht geöffnet: {raison}",
        "en": "Online sales are closed: {raison}"
    },
    "Ce paiement est « {depuis} » : il ne peut pas devenir « {vers} ».": {
        "de": "Diese Zahlung hat den Status «{depuis}» und kann nicht in «{vers}» geändert werden.",
        "en": "This payment is “{depuis}” and cannot be changed to “{vers}”."
    },
    "Lien de paiement invalide ou périmé.": {
        "de": "Der Zahlungslink ist ungültig oder abgelaufen.",
        "en": "The payment link is invalid or has expired."
    },
    "Vous n'avez pas les droits nécessaires pour cette action.": {
        "de": "Sie haben nicht die erforderliche Berechtigung für diese Aktion.",
        "en": "You do not have permission to perform this action."
    },
    "Requête rejetée pour raison de sécurité. Rechargez la page et réessayez.": {
        "de": "Die Anfrage wurde aus Sicherheitsgründen abgelehnt. Laden Sie die Seite neu und versuchen Sie es erneut.",
        "en": "The request was rejected for security reasons. Reload the page and try again."
    },
    "{entite} introuvable.": {
        "de": "{entite} nicht gefunden.",
        "en": "{entite} could not be found."
    },
    "Les données envoyées sont incomplètes ou mal formées.": {
        "de": "Die übermittelten Angaben sind unvollständig oder ungültig.",
        "en": "The submitted details are incomplete or invalid."
    },
    "Aucun théâtre n’est desservi à cette adresse.": {
        "de": "Unter dieser Adresse ist kein Veranstaltungsort verfügbar.",
        "en": "No venue is available at this address."
    },
    "La période d’essai de {nom} est terminée. Les données sont conservées le temps de la prolonger.": {
        "de": "Die Testphase von {nom} ist abgelaufen. Die Daten bleiben bis zur Verlängerung erhalten.",
        "en": "The trial for {nom} has ended. The data is retained while an extension is arranged."
    },
    "{nom} est en cours de préparation. Réessayez dans un instant.": {
        "de": "{nom} wird vorbereitet. Versuchen Sie es gleich erneut.",
        "en": "{nom} is being prepared. Please try again shortly."
    },
    "Contexte de théâtre absent : la requête a été refusée par sécurité.": {
        "de": "Der Veranstaltungsort konnte nicht ermittelt werden. Die Anfrage wurde aus Sicherheitsgründen abgelehnt.",
        "en": "The venue could not be identified. The request was rejected for security reasons."
    },
    "Ce paiement ne désigne aucune commande.": {
        "de": "Diese Zahlung ist keiner Bestellung zugeordnet.",
        "en": "This payment is not linked to an order."
    },
    "Aucune facture n’a été émise pour cette commande.": {
        "de": "Für diese Bestellung wurde keine Rechnung ausgestellt.",
        "en": "No invoice has been issued for this order."
    },
    "Cette commande est déjà passée : il n’y a rien à reprendre.": {
        "de": "Diese Bestellung wurde bereits abgeschlossen.",
        "en": "This order has already been placed and cannot be resumed."
    },
    "Ce panier a été abandonné : choisissez de nouvelles places.": {
        "de": "Dieser Warenkorb wurde aufgegeben. Wählen Sie neue Plätze.",
        "en": "This basket was abandoned. Please select new places."
    },
    "Cette commande ne contient plus aucune place.": {
        "de": "Diese Bestellung enthält keine Plätze mehr.",
        "en": "This order no longer contains any places."
    },
    "Une ligne de cette commande ne désigne aucune place.": {
        "de": "Eine Bestellposition ist keinem Platz zugeordnet.",
        "en": "An order line is not linked to a place."
    },
    "Ce moyen de paiement n’est pas disponible pour ce théâtre.": {
        "de": "Diese Zahlungsart ist für diesen Veranstaltungsort nicht verfügbar.",
        "en": "This payment method is unavailable for this venue."
    },
    "Ce panier a été abandonné : il n’y a plus rien à commander.": {
        "de": "Dieser Warenkorb wurde aufgegeben. Es gibt nichts mehr zu bestellen.",
        "en": "This basket was abandoned and can no longer be ordered."
    },
    "Votre panier est vide : choisissez des places avant de commander.": {
        "de": "Ihr Warenkorb ist leer. Wählen Sie vor der Bestellung Plätze aus.",
        "en": "Your basket is empty. Select places before placing an order."
    },
    "Indiquez vos coordonnées avant de payer : c’est à cette adresse que partiront vos billets.": {
        "de": "Geben Sie vor der Zahlung Ihre Kontaktdaten ein. Ihre Tickets werden an diese Adresse gesendet.",
        "en": "Enter your contact details before paying. Your tickets will be sent to that address."
    },
    "Cette commande est à zéro franc : il n’y a rien à encaisser.": {
        "de": "Diese Bestellung kostet null Franken. Es ist keine Zahlung erforderlich.",
        "en": "This order totals zero francs. No payment is required."
    },
    "Un abonnement se règle séparément des places à l’unité : validez d’abord l’une des deux commandes.": {
        "de": "Abonnemente und Einzeltickets werden getrennt bezahlt. Schliessen Sie zuerst eine der beiden Bestellungen ab.",
        "en": "Subscriptions and individual tickets must be paid separately. Complete one order first."
    },
    "Une commande d’abonnement ne porte que sur une seule formule : validez-les l’une après l’autre.": {
        "de": "Eine Abonnementsbestellung kann nur ein Angebot enthalten. Bestellen Sie die Angebote nacheinander.",
        "en": "A subscription order can contain only one subscription type. Order them separately."
    },
    "Cette commande est déjà réglée.": {
        "de": "Diese Bestellung ist bereits bezahlt.",
        "en": "This order has already been paid."
    },
    "Ce panier a déjà été utilisé pour une commande.": {
        "de": "Dieser Warenkorb wurde bereits für eine Bestellung verwendet.",
        "en": "This basket has already been used for an order."
    },
    "Le tarif « {categorie} » se prend au guichet du théâtre, pas en ligne.": {
        "de": "Der Tarif «{categorie}» ist nur an der Theaterkasse erhältlich.",
        "en": "The “{categorie}” rate is only available at the box office."
    },
    "cette date n’est pas proposée à la vente en ligne. Le guichet du théâtre vous renseignera.": {
        "de": "dieser Termin ist nicht online erhältlich. Bitte wenden Sie sich an die Theaterkasse.",
        "en": "this date is not available online. Please contact the box office."
    },
    "cette représentation a déjà commencé.": {
        "de": "diese Vorstellung hat bereits begonnen.",
        "en": "this performance has already started."
    },
    "« {salle} » est à placement libre : on n’y choisit pas sa place, on indique un nombre d’entrées.": {
        "de": "Bei «{salle}» gilt freie Platzwahl. Geben Sie die Anzahl Eintritte an, statt Plätze auszuwählen.",
        "en": "“{salle}” has unallocated seating. Enter the number of admissions instead of selecting seats."
    },
    "Cette place est déjà dans votre panier.": {
        "de": "Dieser Platz befindet sich bereits in Ihrem Warenkorb.",
        "en": "This place is already in your basket."
    },
    "« {salle} » est une salle numérotée : choisissez vos places sur le plan.": {
        "de": "«{salle}» hat nummerierte Plätze. Wählen Sie Ihre Plätze auf dem Plan.",
        "en": "“{salle}” has numbered seats. Select your places on the plan."
    },
    "« {nom} » impose de choisir une place sur le plan, commune à la série ou par représentation.": {
        "de": "Für «{nom}» müssen Sie auf dem Plan einen gemeinsamen Platz für die Reihe oder einen Platz pro Vorstellung wählen.",
        "en": "For “{nom}”, select a seat on the plan, either for the whole series or for each performance."
    },
    "Choisissez un siège commun ou un siège par date, pas les deux.": {
        "de": "Wählen Sie entweder einen gemeinsamen Platz oder einen Platz je Termin, nicht beides.",
        "en": "Select either one seat for all dates or a seat per date, not both."
    },
    "« {nom} » ne réserve pas de place à l’avance : vous choisirez vos soirées ensuite.": {
        "de": "«{nom}» reserviert keine Plätze im Voraus. Sie wählen Ihre Termine später.",
        "en": "“{nom}” does not reserve places in advance. You will choose your evenings later."
    },
    "« {nom} » ne comporte encore aucune date programmée.": {
        "de": "Für «{nom}» sind noch keine Termine geplant.",
        "en": "“{nom}” has no scheduled dates yet."
    },
    "Choisissez exactement une place pour chaque représentation de la série.": {
        "de": "Wählen Sie genau einen Platz für jede Vorstellung der Reihe.",
        "en": "Select exactly one place for each performance in the series."
    },
    "Une place manque pour une représentation de la série.": {
        "de": "Für eine Vorstellung der Reihe fehlt ein Platz.",
        "en": "A place is missing for a performance in the series."
    },
    "Cet abonnement est déjà dans votre panier.": {
        "de": "Dieses Abonnement befindet sich bereits in Ihrem Warenkorb.",
        "en": "This subscription is already in your basket."
    },
    "Votre panier est vide : il n’y a rien à prolonger.": {
        "de": "Ihr Warenkorb ist leer. Es gibt nichts zu verlängern.",
        "en": "Your basket is empty. There is nothing to extend."
    },
    "Votre panier est vide : ajoutez des places avant de continuer.": {
        "de": "Ihr Warenkorb ist leer. Fügen Sie Plätze hinzu, bevor Sie fortfahren.",
        "en": "Your basket is empty. Add places before continuing."
    },
    "Terminez ou videz votre panier actuel avant d’accepter cette offre.": {
        "de": "Schliessen oder leeren Sie Ihren aktuellen Warenkorb, bevor Sie dieses Angebot annehmen.",
        "en": "Complete or empty your current basket before accepting this offer."
    },
    "Le contenu de cette offre doit être vérifié par la billetterie.": {
        "de": "Der Inhalt dieses Angebots muss von der Kasse geprüft werden.",
        "en": "The box office needs to check the contents of this offer."
    },
    "Cet abonnement ne permet pas de réserver une date actuellement.": {
        "de": "Mit diesem Abonnement kann derzeit kein Termin reserviert werden.",
        "en": "This subscription cannot currently be used to reserve a date."
    },
    "Indiquez une quantité d’entrées.": {
        "de": "Geben Sie die Anzahl Eintritte an.",
        "en": "Enter the number of admissions."
    },
    "Cette catégorie de public n’est pas disponible.": {
        "de": "Diese Besucherkategorie ist nicht verfügbar.",
        "en": "This customer category is unavailable."
    },
    "Il ne reste pas assez d’entrées disponibles.": {
        "de": "Es sind nicht genügend Eintritte verfügbar.",
        "en": "There are not enough admissions available."
    },
    "Choisissez des places distinctes sur le plan.": {
        "de": "Wählen Sie unterschiedliche Plätze auf dem Plan.",
        "en": "Select distinct places on the plan."
    },
    "Une place choisie n’est plus disponible.": {
        "de": "Ein gewählter Platz ist nicht mehr verfügbar.",
        "en": "A selected place is no longer available."
    },
    "Cette formule au choix donne une place par spectacle.": {
        "de": "Dieses Wahlabonnement gewährt einen Platz pro Vorstellung.",
        "en": "This flexible subscription provides one place per show."
    },
    "Ce tarif ou cette zone n’est pas autorisé par votre formule.": {
        "de": "Dieser Tarif oder Bereich ist in Ihrem Abonnement nicht enthalten.",
        "en": "This price or area is not allowed by your subscription."
    },
    "Cette offre a déjà été acceptée. Reprenez sur le navigateur utilisé ou contactez la billetterie.": {
        "de": "Dieses Angebot wurde bereits angenommen. Verwenden Sie denselben Browser oder kontaktieren Sie die Kasse.",
        "en": "This offer has already been accepted. Resume in the browser you used or contact the box office."
    },
    "Cette offre n’est plus disponible.": {
        "de": "Dieses Angebot ist nicht mehr verfügbar.",
        "en": "This offer is no longer available."
    },
    "Les places de cette offre ont été libérées. Contactez la billetterie.": {
        "de": "Die Plätze dieses Angebots wurden freigegeben. Kontaktieren Sie die Kasse.",
        "en": "The places in this offer have been released. Contact the box office."
    },
    "Choisissez au plus {maximum} places.": {
        "de": "Wählen Sie höchstens {maximum} Plätze.",
        "en": "Select no more than {maximum} places."
    },
    "Choisissez une catégorie proposée pour cette date.": {
        "de": "Wählen Sie eine für diesen Termin angebotene Kategorie.",
        "en": "Select a category offered for this date."
    },
    "Cette demande est terminée. Créez une nouvelle demande si nécessaire.": {
        "de": "Diese Anfrage ist abgeschlossen. Erstellen Sie bei Bedarf eine neue Anfrage.",
        "en": "This request is closed. Create a new request if needed."
    },
    "L’offre a été ajoutée à un panier : gérez ce panier ou la commande depuis son parcours habituel.": {
        "de": "Das Angebot wurde einem Warenkorb hinzugefügt. Verwalten Sie den Warenkorb oder die Bestellung über den üblichen Ablauf.",
        "en": "The offer has been added to a basket. Manage that basket or order through the usual process."
    },
    "Le lien de vérification a expiré. Inscrivez-vous à nouveau.": {
        "de": "Der Bestätigungslink ist abgelaufen. Melden Sie sich erneut an.",
        "en": "The verification link has expired. Please register again."
    },
    "Cette date n’est plus proposée à la vente publique.": {
        "de": "Dieser Termin ist nicht mehr im öffentlichen Verkauf.",
        "en": "This date is no longer on public sale."
    },
    "Cette offre n’est plus active.": {
        "de": "Dieses Angebot ist nicht mehr aktiv.",
        "en": "This offer is no longer active."
    },
    "Ce lien de connexion n’est plus valable. Demandez-en un nouveau.": {
        "de": "Dieser Anmeldelink ist nicht mehr gültig. Fordern Sie einen neuen an.",
        "en": "This sign-in link is no longer valid. Request a new one."
    },
    "Cette demande est terminée.": {
        "de": "Diese Anfrage ist abgeschlossen.",
        "en": "This request is closed."
    },
    "La demande a changé. Relisez-la avant de confirmer un acte.": {
        "de": "Die Anfrage hat sich geändert. Lesen Sie sie erneut, bevor Sie eine Aktion bestätigen.",
        "en": "The request has changed. Read it again before confirming an action."
    },
    "Le billet ne correspond pas à la commande indiquée.": {
        "de": "Das Ticket gehört nicht zur angegebenen Bestellung.",
        "en": "The ticket does not belong to the specified order."
    },
    "Cette référence désigne déjà une autre demande.": {
        "de": "Diese Referenz gehört bereits zu einer anderen Anfrage.",
        "en": "This reference is already used by another request."
    },
    "La nouvelle adresse doit différer de votre adresse actuelle.": {
        "de": "Die neue Adresse muss sich von Ihrer aktuellen Adresse unterscheiden.",
        "en": "The new address must differ from your current address."
    },
    "Votre message doit être visible dans votre demande.": {
        "de": "Ihre Nachricht muss in Ihrer Anfrage sichtbar sein.",
        "en": "Your message must be visible in your request."
    },
    "Cette référence appartient à un autre message.": {
        "de": "Diese Referenz gehört zu einer anderen Nachricht.",
        "en": "This reference belongs to another message."
    },
    "Cette demande est terminée. Ouvrez une nouvelle demande en rappelant sa référence.": {
        "de": "Diese Anfrage ist abgeschlossen. Erstellen Sie eine neue Anfrage mit Verweis auf diese Referenz.",
        "en": "This request is closed. Open a new request and mention its reference."
    },
    "La demande a changé. Relisez ses derniers messages avant de poursuivre.": {
        "de": "Die Anfrage hat sich geändert. Lesen Sie vor dem Fortfahren die neuesten Nachrichten.",
        "en": "The request has changed. Read its latest messages before continuing."
    },
    "Votre demande a changé. Relisez-la avant de la retirer.": {
        "de": "Ihre Anfrage hat sich geändert. Lesen Sie sie erneut, bevor Sie sie zurückziehen.",
        "en": "Your request has changed. Read it again before withdrawing it."
    },
    "Cette demande est déjà terminée.": {
        "de": "Diese Anfrage ist bereits abgeschlossen.",
        "en": "This request is already closed."
    },
    "Cette demande ne porte plus de nouvelle adresse à vérifier.": {
        "de": "Diese Anfrage enthält keine neue Adresse mehr zur Bestätigung.",
        "en": "This request no longer has a new address to verify."
    },
    "Votre profil a changé depuis la demande. Contactez la billetterie avant de modifier l’adresse.": {
        "de": "Ihr Profil hat sich seit der Anfrage geändert. Kontaktieren Sie vor einer Adressänderung die Kasse.",
        "en": "Your profile has changed since the request. Contact the box office before changing the address."
    },
    "Ce lien de vérification est expiré ou déjà utilisé.": {
        "de": "Dieser Bestätigungslink ist abgelaufen oder wurde bereits verwendet.",
        "en": "This verification link has expired or has already been used."
    },
    "Session expirée, veuillez vous reconnecter.": {
        "de": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
        "en": "Your session has expired. Please sign in again."
    },
    "Trop de demandes. Réessayez dans une heure.": {
        "de": "Zu viele Anfragen. Versuchen Sie es in einer Stunde erneut.",
        "en": "Too many requests. Please try again in an hour."
    },
    "Trop de requêtes. Patientez un instant.": {
        "de": "Zu viele Anfragen. Bitte warten Sie einen Moment.",
        "en": "Too many requests. Please wait a moment."
    },
    "Une erreur technique est survenue. L’action n’a pas été enregistrée.": {
        "de": "Ein technischer Fehler ist aufgetreten. Die Aktion wurde nicht gespeichert.",
        "en": "A technical error occurred. The action was not saved."
    },
    "Panier introuvable.": {
        "de": "Warenkorb nicht gefunden.",
        "en": "Basket could not be found."
    },
    "Paiement introuvable.": {
        "de": "Zahlung nicht gefunden.",
        "en": "Payment could not be found."
    },
    "Représentation introuvable.": {
        "de": "Vorstellung nicht gefunden.",
        "en": "Performance could not be found."
    },
    "Formule introuvable.": {
        "de": "Abonnement nicht gefunden.",
        "en": "Subscription could not be found."
    },
    "Ligne de panier introuvable.": {
        "de": "Warenkorbposition nicht gefunden.",
        "en": "Basket line could not be found."
    },
    "Souscription introuvable.": {
        "de": "Abonnement nicht gefunden.",
        "en": "Subscription could not be found."
    },
    "Personne introuvable.": {
        "de": "Person nicht gefunden.",
        "en": "Person could not be found."
    },
    "Facture introuvable.": {
        "de": "Rechnung nicht gefunden.",
        "en": "Invoice could not be found."
    },
    "Billet introuvable.": {
        "de": "Ticket nicht gefunden.",
        "en": "Ticket could not be found."
    },
    "Commande introuvable.": {
        "de": "Bestellung nicht gefunden.",
        "en": "Order could not be found."
    },
    "Demande introuvable.": {
        "de": "Anfrage nicht gefunden.",
        "en": "Request could not be found."
    },
    "Demande de liste d’attente introuvable.": {
        "de": "Wartelistenanfrage nicht gefunden.",
        "en": "Waiting-list request could not be found."
    },
    "Catégorie de public introuvable.": {
        "de": "Besucherkategorie nicht gefunden.",
        "en": "Customer category could not be found."
    },
    "Votre profil introuvable.": {
        "de": "Ihr Profil nicht gefunden.",
        "en": "Your profile could not be found."
    },
    "Message de la demande introuvable.": {
        "de": "Nachricht der Anfrage nicht gefunden.",
        "en": "Request message could not be found."
    },
    "Saison en vente introuvable.": {
        "de": "Spielzeit im Verkauf nicht gefunden.",
        "en": "Season on sale could not be found."
    },
    "Date de la formule introuvable.": {
        "de": "Abonnementstermin nicht gefunden.",
        "en": "Subscription date could not be found."
    },
    "Représentation de cette série introuvable.": {
        "de": "Vorstellung dieser Reihe nicht gefunden.",
        "en": "Performance in this series could not be found."
    },
    "Siège introuvable.": {
        "de": "Sitzplatz nicht gefunden.",
        "en": "Seat could not be found."
    },
    "Carte d’abonné introuvable.": {
        "de": "Abonnementskarte nicht gefunden.",
        "en": "Subscription card could not be found."
    },
    "Abonnement introuvable.": {
        "de": "Abonnement nicht gefunden.",
        "en": "Subscription could not be found."
    },
    "Votre panier a expiré : les places retenues ont été remises en vente. Choisissez-les à nouveau — elles sont peut-être encore libres.": {
        "de": "Ihr Warenkorb ist abgelaufen. Die vorgemerkten Plätze sind wieder im Verkauf. Wählen Sie sie erneut aus; möglicherweise sind sie noch frei.",
        "en": "Your basket has expired and the held places have been released. Select them again; they may still be available."
    },
    "Une commande est limitée à {maximum} place(s). Pour un groupe plus important, contactez directement le théâtre.": {
        "de": "Eine Bestellung ist auf {maximum} Plätze begrenzt. Für grössere Gruppen wenden Sie sich direkt an das Theater.",
        "en": "An order is limited to {maximum} places. Contact the theatre directly for larger groups."
    },
    "Votre panier a déjà été prolongé une fois. Terminez votre commande maintenant : les places ne peuvent pas être retenues plus longtemps.": {
        "de": "Ihr Warenkorb wurde bereits einmal verlängert. Schliessen Sie Ihre Bestellung jetzt ab. Die Plätze können nicht länger vorgemerkt bleiben.",
        "en": "Your basket has already been extended once. Complete your order now; the places cannot be held any longer."
    },
    "Le siège {siege} est déjà occupé pour cette représentation.": {
        "de": "Platz {siege} ist für diese Vorstellung bereits belegt.",
        "en": "Seat {siege} is already occupied for this performance."
    },
    "Le siège {siege} est déjà occupé pour {representation}.": {
        "de": "Platz {siege} ist für {representation} bereits belegt.",
        "en": "Seat {siege} is already occupied for {representation}."
    },
    "Votre lien de connexion": {
        "de": "Ihr Anmeldelink",
        "en": "Your sign-in link"
    },
    "Votre lien de connexion — {theatre}": {
        "de": "Ihr Anmeldelink — {theatre}",
        "en": "Your sign-in link — {theatre}"
    },
    "Votre théâtre": {
        "de": "Ihr Theater",
        "en": "Your theatre"
    },
    "Voici votre lien de connexion à votre espace abonné :": {
        "de": "Hier ist der Anmeldelink zu Ihrem Abonnentenbereich:",
        "en": "Here is the sign-in link to your subscriber area:"
    },
    "Ce lien est valable {minutes} minutes et ne fonctionne qu’une seule fois.": {
        "de": "Dieser Link ist {minutes} Minuten gültig und kann nur einmal verwendet werden.",
        "en": "This link is valid for {minutes} minutes and can only be used once."
    },
    "Si vous n’êtes pas à l’origine de cette demande, ignorez simplement ce message.": {
        "de": "Falls Sie diese Anfrage nicht gestellt haben, ignorieren Sie diese Nachricht.",
        "en": "If you did not make this request, simply ignore this message."
    },
    "Veuillez trouver ci-joint votre facture n° {numero} d’un montant de {montant}.": {
        "de": "Im Anhang finden Sie Ihre Rechnung Nr. {numero} über {montant}.",
        "en": "Please find attached invoice no. {numero} for {montant}."
    },
    "Référence de paiement : {reference}": {
        "de": "Zahlungsreferenz: {reference}",
        "en": "Payment reference: {reference}"
    },
    "Votre billet est également joint.": {
        "de": "Ihr Ticket liegt ebenfalls bei.",
        "en": "Your ticket is also attached."
    },
    "Vos {nombre} billets sont également joints.": {
        "de": "Ihre {nombre} Tickets liegen ebenfalls bei.",
        "en": "Your {nombre} tickets are also attached."
    },
    "Cette facture est acquittée : aucun autre règlement n’est attendu.": {
        "de": "Diese Rechnung ist bezahlt. Es ist keine weitere Zahlung erforderlich.",
        "en": "This invoice is paid. No further payment is required."
    },
    "Le bulletin de versement se paie en scannant le code QR depuis votre application bancaire.": {
        "de": "Scannen Sie den QR-Code mit Ihrer Banking-App, um den Einzahlungsschein zu bezahlen.",
        "en": "Scan the QR code with your banking app to pay the payment slip."
    },
    "Facture n° {numero} — {montant}": {
        "de": "Rechnung Nr. {numero} — {montant}",
        "en": "Invoice no. {numero} — {montant}"
    },
    "Généré par ILYGO Sàrl — outil de billetterie pour salles de spectacle et événements · ilygo.ch": {
        "de": "Erstellt mit ILYGO Sàrl — Ticketing für Veranstaltungsorte und Veranstaltungen · ilygo.ch",
        "en": "Generated by ILYGO Sàrl — ticketing for venues and events · ilygo.ch"
    },
    "SPECTACLE": {
        "de": "VORSTELLUNG",
        "en": "SHOW"
    },
    "ÉVÉNEMENT": {
        "de": "VERANSTALTUNG",
        "en": "EVENT"
    },
    "Votre offre de places en liste d’attente": {
        "de": "Ihr Platzangebot von der Warteliste",
        "en": "Your waiting-list place offer"
    },
    "Des places vous sont proposées pour {montant}, jusqu’au {date}.": {
        "de": "Wir bieten Ihnen Plätze für {montant} bis zum {date} an.",
        "en": "Places are offered to you for {montant} until {date}."
    },
    "Consulter l’offre et gérer ma demande": {
        "de": "Angebot ansehen und Anfrage verwalten",
        "en": "View offer and manage my request"
    },
    "La commande, son paiement et sa facture se terminent ensuite dans RidoMio. Pour vous retirer, utilisez ce même lien.": {
        "de": "Bestellung, Zahlung und Rechnung werden anschliessend in RidoMio abgeschlossen. Zum Zurückziehen verwenden Sie denselben Link.",
        "en": "The order, payment and invoice are then completed in RidoMio. Use the same link to withdraw."
    },
    "Votre demande en liste d’attente": {
        "de": "Ihre Wartelistenanfrage",
        "en": "Your waiting-list request"
    },
    "Consultez votre demande ou confirmez-la sous 24 heures.": {
        "de": "Sehen Sie Ihre Anfrage an oder bestätigen Sie sie innerhalb von 24 Stunden.",
        "en": "View your request or confirm it within 24 hours."
    },
    "Cette inscription autorise uniquement les messages relatifs à cette demande. Elle ne garantit aucune place et peut être retirée depuis ce même lien.": {
        "de": "Diese Anmeldung erlaubt nur Nachrichten zu dieser Anfrage. Sie garantiert keinen Platz und kann über denselben Link zurückgezogen werden.",
        "en": "This registration only authorises messages about this request. It does not guarantee places and can be withdrawn using the same link."
    },
    "Gérer ma demande": {
        "de": "Meine Anfrage verwalten",
        "en": "Manage my request"
    },
    "Vérifiez votre nouvelle adresse de contact": {
        "de": "Bestätigen Sie Ihre neue Kontaktadresse",
        "en": "Verify your new contact address"
    },
    "Pour vérifier cette nouvelle adresse sous 24 heures :": {
        "de": "Bestätigen Sie diese neue Adresse innerhalb von 24 Stunden:",
        "en": "To verify this new address within 24 hours:"
    },
    "Ce geste ne change pas encore votre connexion. La billetterie doit ensuite valider votre demande de correction.": {
        "de": "Dadurch wird Ihre Anmeldung noch nicht geändert. Die Kasse muss Ihre Korrekturanfrage anschliessend freigeben.",
        "en": "This does not change your sign-in details yet. The box office must then approve your correction request."
    },
    "Suivi de votre demande auprès de la billetterie": {
        "de": "Aktueller Stand Ihrer Anfrage bei der Kasse",
        "en": "Update on your box-office request"
    },
    "Consultez le suivi et les documents dans votre portail RidoMio.": {
        "de": "Den Verlauf und die Dokumente finden Sie in Ihrem RidoMio-Portal.",
        "en": "View progress and documents in your RidoMio portal."
    },
    "Ouvrir mon portail RidoMio": {
        "de": "Mein RidoMio-Portal öffnen",
        "en": "Open my RidoMio portal"
    },
    "{theatre} — devis de groupe n° {numero}, version {revision}": {
        "de": "{theatre} — Gruppenofferte Nr. {numero}, Version {revision}",
        "en": "{theatre} — group quote no. {numero}, version {revision}"
    },
    "Votre devis de groupe figure en pièce jointe. Les places sont réservées uniquement jusqu’à la fin de l’option indiquée. Contactez la billetterie pour confirmer votre accord.": {
        "de": "Ihre Gruppenofferte liegt bei. Die Plätze sind nur bis zum Ende der angegebenen Option reserviert. Kontaktieren Sie die Kasse, um Ihre Zustimmung zu bestätigen.",
        "en": "Your group quote is attached. Places are only reserved until the stated option deadline. Contact the box office to confirm your agreement."
    },
    "Votre billet pour {spectacle} est joint à ce message. Le règlement du groupe est suivi auprès de son responsable.": {
        "de": "Ihr Ticket für {spectacle} liegt bei. Die Zahlung der Gruppe wird mit der verantwortlichen Person abgewickelt.",
        "en": "Your ticket for {spectacle} is attached. Group payment is managed with the group organiser."
    },
    "{theatre} — votre billet de groupe": {
        "de": "{theatre} — Ihr Gruppenticket",
        "en": "{theatre} — your group ticket"
    },
    "{nombre} place sur {maximum} au maximum": {
        "de": "{nombre} Platz von höchstens {maximum}",
        "en": "{nombre} place out of a maximum of {maximum}"
    },
    "{nombre} places sur {maximum} au maximum": {
        "de": "{nombre} Plätze von höchstens {maximum}",
        "en": "{nombre} places out of a maximum of {maximum}"
    },
    "Fauteuil {place}": {
        "de": "Sitzplatz {place}",
        "en": "Seat {place}"
    },
    "Place standard": {
        "de": "Standardplatz",
        "en": "Standard place"
    },
    "Place accompagnant": {
        "de": "Begleitplatz",
        "en": "Companion place"
    },
    "Active": {
        "de": "Aktiv",
        "en": "Active"
    },
    "Révoquée": {
        "de": "Widerrufen",
        "en": "Revoked"
    },
    "Série": {
        "de": "Feste Reihe",
        "en": "Fixed series"
    },
    "Au choix": {
        "de": "Wahlabonnement",
        "en": "Flexible subscription"
    },
    "Carnet": {
        "de": "Mehrfachkarte",
        "en": "Multi-entry pass"
    },
    "Devis groupe n° {numero} — version {revision}": {
        "de": "Gruppenofferte Nr. {numero} — Version {revision}",
        "en": "Group quote no. {numero} — version {revision}"
    },
    "Contact et payeur : {nom}": {
        "de": "Kontakt und zahlungspflichtige Person: {nom}",
        "en": "Contact and payer: {nom}"
    },
    "Option jusqu’au {date} — {statut}": {
        "de": "Option bis {date} — {statut}",
        "en": "Option until {date} — {statut}"
    },
    "Ce devis ne constitue pas une facture. Les places ne sont promises que jusqu’à la fin de l’option et sous réserve de confirmation. La facture et les billets sont émis à la confirmation humaine du dossier.": {
        "de": "Diese Offerte ist keine Rechnung. Die Plätze sind nur bis zum Optionsende und unter Vorbehalt der Bestätigung vorgemerkt. Rechnung und Tickets werden nach der manuellen Bestätigung des Dossiers ausgestellt.",
        "en": "This quote is not an invoice. Places are only held until the option deadline and subject to confirmation. The invoice and tickets are issued when a member of staff confirms the booking."
    },
    "Total proposé : CHF {montant}": {
        "de": "Angebotener Gesamtbetrag: CHF {montant}",
        "en": "Proposed total: CHF {montant}"
    },
    "Échéancier prévu après confirmation :": {
        "de": "Vorgesehener Zahlungsplan nach Bestätigung:",
        "en": "Planned payment schedule after confirmation:"
    },
    "Option": {
        "de": "Option",
        "en": "Option"
    },
    "Confirmé": {
        "de": "Bestätigt",
        "en": "Confirmed"
    },
    "Annulé": {
        "de": "Storniert",
        "en": "Cancelled"
    },
    "Expiré": {
        "de": "Abgelaufen",
        "en": "Expired"
    },
    "Le suivi de votre demande a été mis à jour.": {
        "de": "Der Stand Ihrer Anfrage wurde aktualisiert.",
        "en": "Your request has been updated."
    },
    "La billetterie a répondu à votre demande.": {
        "de": "Die Kasse hat auf Ihre Anfrage geantwortet.",
        "en": "The box office has replied to your request."
    },
    "La billetterie a réalisé la correction de votre demande. Consultez le résultat et les documents dans votre portail.": {
        "de": "Die Kasse hat die angefragte Korrektur vorgenommen. Das Ergebnis und die Dokumente finden Sie in Ihrem Portal.",
        "en": "The box office has carried out your requested correction. View the result and documents in your portal."
    },
    "Déductions (chèques culture, bons)": {
        "de": "Abzüge (Kulturchecks, Gutscheine)",
        "en": "Deductions (culture vouchers, vouchers)"
    },
    "Ajustements": {
        "de": "Korrekturen",
        "en": "Adjustments"
    },
    "Acompte ou règlement déjà reçu": {
        "de": "Bereits erhaltene Anzahlung oder Zahlung",
        "en": "Deposit or payment already received"
    },
    "Vente de billets": {
        "de": "Ticketverkauf",
        "en": "Ticket sales"
    },
    "Abonnement « {nom} » — {saison}": {
        "de": "Abonnement «{nom}» — {saison}",
        "en": "Subscription “{nom}” — {saison}"
    },
    "{nombre} soirée imposée, votre fauteuil réservé pour toute la saison.": {
        "de": "{nombre} fester Abend, Ihr Sitzplatz ist für die ganze Spielzeit reserviert.",
        "en": "{nombre} fixed evening, with your seat reserved for the whole season."
    },
    "{nombre} soirées imposées, votre fauteuil réservé pour toute la saison.": {
        "de": "{nombre} feste Abende, Ihr Sitzplatz ist für die ganze Spielzeit reserviert.",
        "en": "{nombre} fixed evenings, with your seat reserved for the whole season."
    },
    "{nombre} spectacle au choix dans la saison. Vous choisirez vos soirées et vos places plus tard.": {
        "de": "{nombre} Vorstellung nach Wahl in der Spielzeit. Termine und Plätze wählen Sie später.",
        "en": "{nombre} show of your choice in the season. You will choose your evenings and places later."
    },
    "{nombre} spectacles au choix dans la saison. Vous choisirez vos soirées et vos places plus tard.": {
        "de": "{nombre} Vorstellungen nach Wahl in der Spielzeit. Termine und Plätze wählen Sie später.",
        "en": "{nombre} shows of your choice in the season. You will choose your evenings and places later."
    },
    "{nombre} entrée à utiliser librement, seul ou à plusieurs le même soir. Vous choisirez vos soirées plus tard.": {
        "de": "{nombre} frei nutzbarer Eintritt, allein oder mit mehreren Personen am selben Abend. Die Termine wählen Sie später.",
        "en": "{nombre} admission to use freely, alone or with others on the same evening. You will choose your evenings later."
    },
    "{nombre} entrées à utiliser librement, seul ou à plusieurs le même soir. Vous choisirez vos soirées plus tard.": {
        "de": "{nombre} frei nutzbare Eintritte, allein oder mit mehreren Personen am selben Abend. Die Termine wählen Sie später.",
        "en": "{nombre} admissions to use freely, alone or with others on the same evening. You will choose your evenings later."
    },
    "sur {total} — {nombre} déjà vu": {
        "de": "von {total} — {nombre} bereits besucht",
        "en": "out of {total} — {nombre} already attended"
    },
    "sur {total} — {nombre} déjà vus": {
        "de": "von {total} — {nombre} bereits besucht",
        "en": "out of {total} — {nombre} already attended"
    },
    "la billetterie en ligne de ce théâtre n’est pas ouverte. Contactez le guichet.": {
        "de": "der Onlineverkauf dieses Theaters ist nicht geöffnet. Kontaktieren Sie die Kasse.",
        "en": "this theatre’s online box office is closed. Contact the box office."
    },
    "La billetterie en ligne de ce théâtre n’est pas ouverte. Contactez le guichet.": {
        "de": "Der Onlineverkauf dieses Theaters ist nicht geöffnet. Kontaktieren Sie die Kasse.",
        "en": "This theatre’s online box office is closed. Contact the box office."
    },
    "La vente en ligne n’est pas ouverte : la billetterie en ligne de ce théâtre n’est pas ouverte. Contactez le guichet.": {
        "de": "Der Onlineverkauf ist nicht geöffnet: der Onlineverkauf dieses Theaters ist nicht geöffnet. Kontaktieren Sie die Kasse.",
        "en": "Online sales are closed: this theatre’s online box office is closed. Contact the box office."
    },
    "aucune salle n’est configurée pour l’instant.": {
        "de": "es ist derzeit kein Veranstaltungsort konfiguriert.",
        "en": "no venue has been configured yet."
    },
    "Aucune salle n’est configurée pour l’instant.": {
        "de": "Es ist derzeit kein Veranstaltungsort konfiguriert.",
        "en": "No venue has been configured yet."
    },
    "La vente en ligne n’est pas ouverte : aucune salle n’est configurée pour l’instant.": {
        "de": "Der Onlineverkauf ist nicht geöffnet: es ist derzeit kein Veranstaltungsort konfiguriert.",
        "en": "Online sales are closed: no venue has been configured yet."
    },
    "aucune saison n’est en vente pour l’instant.": {
        "de": "es ist derzeit keine Spielzeit im Verkauf.",
        "en": "no season is currently on sale."
    },
    "Aucune saison n’est en vente pour l’instant.": {
        "de": "Es ist derzeit keine Spielzeit im Verkauf.",
        "en": "No season is currently on sale."
    },
    "La vente en ligne n’est pas ouverte : aucune saison n’est en vente pour l’instant.": {
        "de": "Der Onlineverkauf ist nicht geöffnet: es ist derzeit keine Spielzeit im Verkauf.",
        "en": "Online sales are closed: no season is currently on sale."
    },
    "la prochaine saison n’est pas encore ouverte à la vente. Revenez bientôt.": {
        "de": "die nächste Spielzeit ist noch nicht im Verkauf. Schauen Sie bald wieder vorbei.",
        "en": "the next season is not on sale yet. Please check back soon."
    },
    "La prochaine saison n’est pas encore ouverte à la vente. Revenez bientôt.": {
        "de": "Die nächste Spielzeit ist noch nicht im Verkauf. Schauen Sie bald wieder vorbei.",
        "en": "The next season is not on sale yet. Please check back soon."
    },
    "La vente en ligne n’est pas ouverte : la prochaine saison n’est pas encore ouverte à la vente. Revenez bientôt.": {
        "de": "Der Onlineverkauf ist nicht geöffnet: die nächste Spielzeit ist noch nicht im Verkauf. Schauen Sie bald wieder vorbei.",
        "en": "Online sales are closed: the next season is not on sale yet. Please check back soon."
    },
    "les abonnés de la saison passée renouvellent actuellement leurs places. La vente au public ouvrira à la fin de cette période.": {
        "de": "die Abonnentinnen und Abonnenten der vergangenen Spielzeit verlängern derzeit ihre Plätze. Der öffentliche Verkauf beginnt danach.",
        "en": "last season’s subscribers are currently renewing their places. Public sales will open after this period."
    },
    "Les abonnés de la saison passée renouvellent actuellement leurs places. La vente au public ouvrira à la fin de cette période.": {
        "de": "Die Abonnentinnen und Abonnenten der vergangenen Spielzeit verlängern derzeit ihre Plätze. Der öffentliche Verkauf beginnt danach.",
        "en": "Last season’s subscribers are currently renewing their places. Public sales will open after this period."
    },
    "La vente en ligne n’est pas ouverte : les abonnés de la saison passée renouvellent actuellement leurs places. La vente au public ouvrira à la fin de cette période.": {
        "de": "Der Onlineverkauf ist nicht geöffnet: die Abonnentinnen und Abonnenten der vergangenen Spielzeit verlängern derzeit ihre Plätze. Der öffentliche Verkauf beginnt danach.",
        "en": "Online sales are closed: last season’s subscribers are currently renewing their places. Public sales will open after this period."
    },
    "la saison est terminée.": {
        "de": "die Spielzeit ist beendet.",
        "en": "the season has ended."
    },
    "La saison est terminée.": {
        "de": "Die Spielzeit ist beendet.",
        "en": "The season has ended."
    },
    "La vente en ligne n’est pas ouverte : la saison est terminée.": {
        "de": "Der Onlineverkauf ist nicht geöffnet: die Spielzeit ist beendet.",
        "en": "Online sales are closed: the season has ended."
    },
    "Les abonnements de cette saison se prennent au guichet du théâtre, pas en ligne. Contactez-nous pour souscrire.": {
        "de": "Abonnemente für diese Spielzeit sind nur an der Theaterkasse erhältlich. Kontaktieren Sie uns für den Abschluss.",
        "en": "Subscriptions for this season are only available at the box office. Contact us to subscribe."
    },
    "Le siège {siege} est retenu par un autre visiteur jusqu’à {heure} : il n’est pas disponible pour l’instant.": {
        "de": "Platz {siege} ist bis {heure} für einen anderen Besucher vorgemerkt und derzeit nicht verfügbar.",
        "en": "Seat {siege} is held by another visitor until {heure} and is currently unavailable."
    }
}
